import { InputError } from '../components/InputError.js';
import CartService from '../service/CartService.js';
// document.body.className +=  ' disable_background_scroll';
// document.body.className = document.body.className.replace("disable_background_scroll","");

export class RemoveItem extends React.Component {
  constructor(props) {
    document.body.className += ' disable_background_scroll';
    super(props);
    var data =
      this.props.data != undefined
        ? this.props.data
        : { id: 0, name: '', img: '', type: '' };
    this.state = {
      id: data.id,
      name: data.name,
      ppsswitch: 1,
      type: data.type,
      img: data.img,
      error: '',
      phone:null,
      email:null
    };
    this.dissmissmodal = this.dissmissmodal.bind(this);
  }

  removeFromCart = () => {
    document.body.className = document.body.className.replace(
      'disable_background_scroll',
      ''
    ); 
        $('.cart-sec #cart_count').text(localStorage.getItem('mycart_count')); 
    this.props.removeFromCart(this.state);
  };

  dissmissmodal() {
    document.body.className = document.body.className.replace(
      'disable_background_scroll',
      ''
    );
    // $('.cart-sec #cart_count').text(localStorage.getItem('mycart_count')); 
    this.props.dissmissmodal();
  }

  render() {
    const { id, name, price, discount_price, type, desc, img } = this.state;
    return (
      <div
        className="modal show "
        data-keyboard="false"
        data-backdrop="static"
        id="remove"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="remove-cart">
          <button
            type="button"
            className="close cart-close"
            onClick={this.dissmissmodal}
          >
            ×
          </button>
          <div className="d-flex">
            <div className="cart-img">
              <img
                src={img}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = default_img;
                }}
              />
            </div>
            <div className="cart-text">
              <h5>{name}</h5>
              <p>Are you sure you want to remove this course?</p>
            </div>
          </div>
          <div className="d-flex justify-content-end w-100 mt-1 remove-btm-text">
            <span className="text-blue" onClick={this.dissmissmodal}>
              Cancel
            </span>
            <span className="text-blue" onClick={this.removeFromCart}>
              Remove
            </span>
          </div>
        </div>
      </div>
    );
  }
}

export class EmailVerificationCheckModal extends React.Component {
  constructor(props) {
    super(props);
    document.body.className += ' disable_background_scroll';

    // var data = (this.props.data != undefined)?this.props.data:{id:0,name:'',img:'',type:''};
    // 		this.state = {
    // 	id : data.id,
    // 	name :data.name,
    // 	type :data.type,
    // 	img : data.img,
    // };
    // this.dissmissmodal = this.dissmissmodal.bind(this);
    this.state = { emailVerifyConfirm: false, emailResendDone: false };
  }

  confirmVerify = () => {
    return (
      <div className="modal-content">
        <div className="modal-body">
          <div className="icon-align text-center">
            <span className="alert-icon">
              <svg
                width={512}
                height={512}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: 'new 0 0 512 512' }}
                xmlSpace="preserve"
                className
              >
                {' '}
                <g transform="matrix(-1,0,0,1,512.0009765625,0)">
                  {' '}
                  <g xmlns="http://www.w3.org/2000/svg">
                    {' '}
                    <path
                      style={{}}
                      d="M506.086,194.207l2.207-2.825l3.708,2.825v300.138c-0.029,9.739-7.917,17.626-17.655,17.655H17.655 C7.917,511.971,0.029,504.083,0,494.345V194.207l3.708-2.825l2.207,2.825H506.086z"
                      fill="#1e88e5"
                      data-original="#ff5364"
                      className
                    />{' '}
                    <path
                      style={{}}
                      d="M508.292,191.382l-2.207,2.825L264.828,379.586h-17.655L5.914,194.207l-2.207-2.825l84.568-65.766 L204.623,35.31l40.695-31.603c6.263-4.943,15.1-4.943,21.363,0l40.695,31.603l116.348,90.306L508.292,191.382z"
                      fill="#64b5f6"
                      data-original="#802d40"
                      className
                    />{' '}
                    <path
                      style={{}}
                      d="M423.724,52.965v204.535L264.828,379.586h-17.655L88.276,257.501V52.965 c0.029-9.739,7.917-17.626,17.655-17.655h300.138C415.808,35.339,423.695,43.227,423.724,52.965z"
                      fill="#eceff1"
                      data-original="#f0c419"
                      className
                    />{' '}
                    <g>
                      {' '}
                      <path
                        style={{}}
                        d="M167.724,105.931h176.552c4.875,0,8.828-3.952,8.828-8.828c0-4.875-3.952-8.828-8.828-8.828 H167.724c-4.875,0-8.828,3.952-8.828,8.828C158.897,101.979,162.849,105.931,167.724,105.931z"
                        fill="#90a4ae"
                        data-original="#3d324c"
                        className
                      />{' '}
                      <path
                        style={{}}
                        d="M344.276,141.241H167.724c-4.875,0-8.828,3.952-8.828,8.828s3.952,8.828,8.828,8.828h176.552 c4.875,0,8.828-3.952,8.828-8.828S349.151,141.241,344.276,141.241z"
                        fill="#90a4ae"
                        data-original="#3d324c"
                        className
                      />{' '}
                      <path
                        style={{}}
                        d="M344.276,194.207h-79.448c-4.875,0-8.828,3.952-8.828,8.828s3.952,8.828,8.828,8.828h79.448 c4.875,0,8.828-3.952,8.828-8.828S349.151,194.207,344.276,194.207z"
                        fill="#90a4ae"
                        data-original="#3d324c"
                        className
                      />{' '}
                    </g>{' '}
                    <path
                      style={{}}
                      d="M508.557,504.761c-3.295,4.561-8.586,7.255-14.212,7.239H17.655 c-5.627,0.017-10.917-2.678-14.212-7.239l202.24-157.043l39.636-30.808c6.263-4.943,15.1-4.943,21.363,0l39.636,30.808 L508.557,504.761z"
                      fill="#2196f3"
                      data-original="#df4d60"
                      className
                    />{' '}
                  </g>{' '}
                  <g xmlns="http://www.w3.org/2000/svg" />{' '}
                  <g xmlns="http://www.w3.org/2000/svg" />{' '}
                  <g xmlns="http://www.w3.org/2000/svg" />{' '}
                  <g xmlns="http://www.w3.org/2000/svg" />{' '}
                  <g xmlns="http://www.w3.org/2000/svg" />{' '}
                  <g xmlns="http://www.w3.org/2000/svg" />{' '}
                  <g xmlns="http://www.w3.org/2000/svg" />{' '}
                  <g xmlns="http://www.w3.org/2000/svg" />{' '}
                  <g xmlns="http://www.w3.org/2000/svg" />{' '}
                  <g xmlns="http://www.w3.org/2000/svg" />{' '}
                  <g xmlns="http://www.w3.org/2000/svg" />{' '}
                  <g xmlns="http://www.w3.org/2000/svg" />{' '}
                  <g xmlns="http://www.w3.org/2000/svg" />{' '}
                  <g xmlns="http://www.w3.org/2000/svg" />{' '}
                  <g xmlns="http://www.w3.org/2000/svg" />{' '}
                </g>
              </svg>
            </span>
          </div>
          <h5 className="message-body text-center">Verify Email Address</h5>
          <p>
            The verification email has been sent. Check your inbox and verify.
          </p>

          {!this.state.emailResendDone ? (
            <p id="resend_message">
              Didn't receive an email?{' '}
              <a onClick={this.verifyEmailResend} href="javascript:void(0)">
                Resend
              </a>
            </p>
          ) : (
            <p id="resend_message">Verify mail sent </p>
          )}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            data-dismiss="modal"
            className="btn btn-blue orange-flat-btn checkout_verify_mail_close"
            onClick={this.props.closeCallBack}
          >
            Okay
          </button>
        </div>
      </div>
    );
  };
  checkVerifyDomain = () => {
    return (
      <div className="modal-content">
        <div className="modal-body">
          <div className="icon-align text-center">
            <span className="alert-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 409.32 509.11"
              >
                <defs>
                  <style
                    dangerouslySetInnerHTML={{
                      __html:
                        '.cls-1{fill:#ebeef0;}.cls-2{fill:#2195f2;}.cls-3{fill:#1e87e4;}.cls-4{fill:#64b4f5;}.cls-5{fill:#8fa3ad;}.cls-6{fill:#ffba00;}.cls-7{fill:#fff;}.cls-8{fill:#fcfcfc;}',
                    }}
                  />
                </defs>
                <g id="Layer_2" data-name="Layer 2">
                  <g id="Layer_1-2" data-name="Layer 1">
                    <path
                      className="cls-1"
                      d="M72.68,0H336.23c15.36,2.93,22.91,12.08,22.94,28,.05,27.92,0,55.83,0,83.75a15.2,15.2,0,0,1-.14,2.78c.43,21.89.09,43.78.19,65.67a20.36,20.36,0,0,1-.36,4.34c-.46,2.72-2.77,3.78-4.75,5q-27,17.13-53.89,34.31c-19.2,12.2-38.36,24.48-57.61,36.61-1.46.92-2.84,2-4.64,2.22-2,.07-3.46-1.18-5-2.19-6.41-4.23-12.85-8.42-19.15-12.81s-12.36-4.47-18.72,0-12.75,8.56-19.16,12.8c-1.53,1-3,2.27-5,2.24-3.76-.83-6.6-3.4-9.71-5.37q-52.86-33.63-105.73-67.26c-2.19-1.39-4.83-2.45-5.5-5.45a23.58,23.58,0,0,1-.39-5.16q0-29.65,0-59.32c0-1.86.37-3.69.23-5.55-.32-10-.11-19.95-.13-29.92,0-19.28-.11-38.57,0-57.86.07-9.76,3.82-17.76,12-23.52C65.11,1,69,.88,72.68,0Z"
                    />
                    <path
                      className="cls-2"
                      d="M170.87,262.14c8-4.29,15.16-9.8,22.73-14.71,9.31-6.05,12.39-6.05,21.71,0,7.57,4.91,14.75,10.43,22.72,14.71a10.07,10.07,0,0,1,4.65,2.14q79.4,52.86,158.72,105.81c4.24,2.82,7.82,6.05,7.9,11.67,0,4.8.34,9.7-2,14.07-4.63,8.64-11.61,13.52-21.78,13.5q-76.24-.09-152.49,0-104.58,0-209.17,0c-9.25,0-16-3.87-21.1-11.35C.84,395.21,1,391.92,0,389v-8.79C.65,376,3.08,373,6.56,370.71q80.19-53.38,160.33-106.87A8.78,8.78,0,0,1,170.87,262.14Z"
                    />
                    <path
                      className="cls-3"
                      d="M170.87,262.14C160.48,270,149.41,276.8,138.6,284Q73.37,327.66,8,371a23.66,23.66,0,0,0-8,9.14v-226c1.38-1.08,2.55-.14,3.62.53,15.15,9.47,30.17,19.13,45.25,28.7,1.08.68,1.5,1.82,2.34,2.64Z"
                    />
                    <path
                      className="cls-4"
                      d="M0,153.34l51-38.89q.09,35.78.17,71.56Q26.69,170.53,2.14,155.06A14.08,14.08,0,0,0,0,154.14Z"
                    />
                    <path
                      className="cls-3"
                      d="M408.8,154.19c0,1.46.1,2.92.1,4.38V375.75c0,1.46-.09,2.92-.13,4.38-1.79-4.16-4.82-7.07-8.59-9.58q-80.06-53.25-160-106.68a26.83,26.83,0,0,1-2.13-1.73L357.69,186a11.08,11.08,0,0,1,3.71-3.49c13.53-8.7,27.17-17.24,40.72-25.92C404.09,155.34,405.87,153,408.8,154.19Z"
                    />
                    <path
                      className="cls-5"
                      d="M204.42,51.12q44.29,0,88.58,0c10,0,16.33,8.8,12.69,17.58a12.17,12.17,0,0,1-11.84,7.93c-7.31.09-14.63,0-21.94,0q-77.42,0-154.81,0c-3.54,0-6.9-.36-9.79-2.62A12.54,12.54,0,0,1,103,59.83c1.84-5.46,6.32-8.68,12.5-8.69Q159.94,51.08,204.42,51.12Z"
                    />
                    <path
                      className="cls-5"
                      d="M204.32,127.78q-44.3,0-88.58,0c-9.75,0-16-8.64-12.61-17.35,1.84-4.74,5.49-7.36,10.49-8.11a17.26,17.26,0,0,1,2.39-.07q88.38,0,176.75,0c5.73,0,10.15,2.15,12.64,7.35a12.62,12.62,0,0,1-11.31,18.17c-8.24.19-16.49,0-24.74,0Q236.83,127.8,204.32,127.78Z"
                    />
                    <path
                      className="cls-5"
                      d="M166.08,153.35c17,0,34,0,51,0A12.37,12.37,0,0,1,229.26,162,12.52,12.52,0,0,1,225,176.25a12.19,12.19,0,0,1-7.77,2.64q-51,0-102.09,0A12.61,12.61,0,0,1,102.25,166c.08-7.12,5.64-12.56,13.18-12.59C132.31,153.3,149.19,153.35,166.08,153.35Z"
                    />
                    <path
                      className="cls-4"
                      d="M408.8,154.19c-8.42,4.18-15.93,9.83-23.91,14.73-9.13,5.6-18.14,11.39-27.2,17.09q.09-35.77.17-71.56l49.66,37.87C408.13,152.79,408.85,153.24,408.8,154.19Z"
                    />
                    <g id="Group_501" data-name="Group 501">
                      <g id="Group_495" data-name="Group 495">
                        <g id="Ellipse_108" data-name="Ellipse 108">
                          <circle
                            className="cls-6"
                            cx="204.86"
                            cy="415.96"
                            r="93.15"
                          />
                          <path
                            className="cls-7"
                            d="M204.86,509.11A93.15,93.15,0,1,1,298,416,93.25,93.25,0,0,1,204.86,509.11Zm0-167.67A74.52,74.52,0,1,0,279.38,416,74.6,74.6,0,0,0,204.86,341.44Z"
                          />
                        </g>
                        <g id="Group_492" data-name="Group 492">
                          <path
                            id="Path_90"
                            data-name="Path 90"
                            className="cls-8"
                            d="M216.76,397.11v25.38c0,5.59-3.72,8.73-10.28,8.75-2.53,0-5.06,0-7.59,0-5.76-.1-9.59-3.34-9.6-8.22q0-26.08,0-52.16c0-5,3.84-8.21,9.72-8.25h8c6,0,9.78,3.24,9.79,8.35C216.78,379.68,216.76,388.39,216.76,397.11Z"
                          />
                          <path
                            id="Path_91"
                            data-name="Path 91"
                            className="cls-8"
                            d="M203,441.21a13.67,13.67,0,1,1-.06,0Z"
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </span>
          </div>
          <p className="message-body text-center">
            It's seems like you are not verified your email address, <br /> You
            won't receive any notification in future
          </p>
          <p>Do you want to continue?</p>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-continue"
            onClick={() => this.props.callBackEmailVerifySkip()}
          >
            Continue
          </button>
          <button
            type="button"
            className="btn btn-blue orange-flat-btn"
            onClick={this.verifyEmailSend}
          >
            Verify Mail
          </button>
        </div>
      </div>
    );
  };

  verifyEmailSend = async () => {
    let apiRes = await fetch(siteUrl + 'api/sendVerificationMail');
    this.setState({ emailVerifyConfirm: true });
    // emailResendDone:true
    // this.props.checkOut();
  };
  verifyEmailResend = async () => {
    let apiRes = await fetch(siteUrl + 'api/sendVerificationMail');
    this.setState({ emailResendDone: true });
    setTimeout(() => {
      this.setState({ emailResendDone: false });
      // this.props.checkOut();
    }, 60000);
  };

  render() {
    return (
      <div
        className="modal show fade alert-modal-new warning-alert my_modal_alert in"
        id="email_verification_modal"
        role="dialog"
      >
        <div className="modal-dialog modal-small">
          {this.state.emailVerifyConfirm
            ? this.confirmVerify()
            : this.checkVerifyDomain()}
        </div>
      </div>
    );
  }
}

export class CouponApplied extends React.Component {
  constructor(props) {
    document.body.className += ' disable_background_scroll';
    super(props);
    this.state = {
      coupondiscount: this.props.coupondiscount.toFixed(2),
      couponname: _couponApplied.code,
    };
  }

  dismiss = () => {
    __prev_dis = this.props.coupondiscount.toFixed(2);

    document.body.className = document.body.className.replace(
      'disable_background_scroll',
      ''
    );
    this.props.cb_dismiss();
  };

  render() {
    return (
      <div
        className="modal show"
        id="couponcode-applied"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="coupon-applied-section">
          <div className="coupon-code-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="67"
              height="67"
              viewBox="0 0 67 67"
            >
              <path
                id="Polygon_1"
                data-name="Polygon 1"
                d="M31.487,1.822a3,3,0,0,1,4.026,0L40.3,6.153a3,3,0,0,0,2.494.737L49.134,5.86a3,3,0,0,1,3.375,2.171l1.721,6.307a3,3,0,0,0,1.683,1.955l5.931,2.618A3,3,0,0,1,63.5,22.539l-1.939,6.284a3,3,0,0,0,.362,2.536l3.612,5.477a3,3,0,0,1-.566,3.941L59.988,45a3,3,0,0,0-1.061,2.339l.107,6.567a3,3,0,0,1-2.618,3.025l-6.393.82a3,3,0,0,0-2.176,1.407l-3.4,5.537a3,3,0,0,1-3.859,1.134L34.8,63.034a3,3,0,0,0-2.6,0l-5.791,2.79a3,3,0,0,1-3.859-1.134l-3.4-5.537a3,3,0,0,0-2.176-1.407l-6.393-.82A3,3,0,0,1,7.966,53.9l.107-6.567A3,3,0,0,0,7.012,45L2.031,40.778a3,3,0,0,1-.566-3.941L5.077,31.36a3,3,0,0,0,.362-2.536L3.5,22.539A3,3,0,0,1,5.156,18.91l5.931-2.618a3,3,0,0,0,1.683-1.955l1.721-6.307A3,3,0,0,1,17.866,5.86L24.208,6.89A3,3,0,0,0,26.7,6.153Z"
                fill="#4fd3af"
              />
              <g id="percent" transform="translate(24.019 24.019)">
                <line
                  id="Line_39"
                  data-name="Line 39"
                  x1={18}
                  y2={18}
                  transform="translate(0.981 0.98)"
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={3}
                />
                <circle
                  id="Ellipse_31"
                  data-name="Ellipse 31"
                  cx={3}
                  cy={3}
                  r={3}
                  transform="translate(-0.019 -0.02)"
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={3}
                />
                <circle
                  id="Ellipse_32"
                  data-name="Ellipse 32"
                  cx={3}
                  cy={3}
                  r={3}
                  transform="translate(13.981 13.98)"
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={3}
                />
              </g>
            </svg>
          </div>
          <h2>‘{this.state.couponname}’ Applied</h2>
          <h1>
            {current_currency}
            {this.state.coupondiscount}
          </h1>
          <p>
            {(this.props.is_bfo) ? 
              'Savings with this coupon' :
              ((Number(this.props.coupon_detail.coupon_limit) >= Number(this.props.coupon_detail.number_learner_count))
              ? 'Savings with this coupon' :
              'Not Sufficient Subscription remaining, Do you want to apply across ' + this.props.coupon_detail.coupon_limit +  ((this.props.coupon_detail.coupon_limit > 1) ? ' learners' : ' learner'))      
            }
          </p>
          <div className="border-bottom mt-15 w-100" />
          <div
            className="bluetext mt-15 cart-success-text"
            onClick={this.dismiss}
          >
            YAY!
          </div>
          {(this.props.is_bfo) ? '' :
            ((Number(this.props.coupon_detail.coupon_limit) < Number(this.props.coupon_detail.number_learner_count))
              ?  (<div
                className="redtext mt-15 cart-success-text" style={{backgroundColor: "red"}}
                onClick={this.props.removeCoupon}
              >
                No
              </div>):
              '')            
          }
        </div>
      </div>
    );
  }
}

export class PackageLicenseApplied extends React.Component {
  constructor(props) {
    document.body.className += ' disable_background_scroll';
    super(props);
  }

  dismiss = () => {
    document.body.className = document.body.className.replace(
      'disable_background_scroll',
      ''
    );
    this.props.removePackage('test');
  };

  render() {
    return (
      <div
        className="modal show"
        id="couponcode-applied"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="coupon-applied-section">
          <div className="coupon-code-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="67"
              height="67"
              viewBox="0 0 67 67"
            >
              <path
                id="Polygon_1"
                data-name="Polygon 1"
                d="M31.487,1.822a3,3,0,0,1,4.026,0L40.3,6.153a3,3,0,0,0,2.494.737L49.134,5.86a3,3,0,0,1,3.375,2.171l1.721,6.307a3,3,0,0,0,1.683,1.955l5.931,2.618A3,3,0,0,1,63.5,22.539l-1.939,6.284a3,3,0,0,0,.362,2.536l3.612,5.477a3,3,0,0,1-.566,3.941L59.988,45a3,3,0,0,0-1.061,2.339l.107,6.567a3,3,0,0,1-2.618,3.025l-6.393.82a3,3,0,0,0-2.176,1.407l-3.4,5.537a3,3,0,0,1-3.859,1.134L34.8,63.034a3,3,0,0,0-2.6,0l-5.791,2.79a3,3,0,0,1-3.859-1.134l-3.4-5.537a3,3,0,0,0-2.176-1.407l-6.393-.82A3,3,0,0,1,7.966,53.9l.107-6.567A3,3,0,0,0,7.012,45L2.031,40.778a3,3,0,0,1-.566-3.941L5.077,31.36a3,3,0,0,0,.362-2.536L3.5,22.539A3,3,0,0,1,5.156,18.91l5.931-2.618a3,3,0,0,0,1.683-1.955l1.721-6.307A3,3,0,0,1,17.866,5.86L24.208,6.89A3,3,0,0,0,26.7,6.153Z"
                fill="#4fd3af"
              />
              <g id="percent" transform="translate(24.019 24.019)">
                <line
                  id="Line_39"
                  data-name="Line 39"
                  x1={18}
                  y2={18}
                  transform="translate(0.981 0.98)"
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={3}
                />
                <circle
                  id="Ellipse_31"
                  data-name="Ellipse 31"
                  cx={3}
                  cy={3}
                  r={3}
                  transform="translate(-0.019 -0.02)"
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={3}
                />
                <circle
                  id="Ellipse_32"
                  data-name="Ellipse 32"
                  cx={3}
                  cy={3}
                  r={3}
                  transform="translate(13.981 13.98)"
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={3}
                />
              </g>
            </svg>
          </div>
          <h2>License Price Applied</h2>
          <p>
            License Price Eligible.
          </p>
          <div className="border-bottom mt-15 w-100" />
          <div
            className="bluetext mt-15 cart-success-text"
            onClick={this.dismiss} style={{marginTop: "10px"}}
          >
            YAY!
          </div>
        </div>
      </div>
    );
  }
}

export class CouponModal extends React.Component {
  constructor(props) {
    document.body.className += ' disable_background_scroll';
    super(props);
    var data =
      this.props.data != undefined
        ? this.props.data
        : { id: 0, name: '', img: '', type: '' };
    this.state = {
      id: data.id,
      name: data.name,
      type: data.type,
      img: data.img,
      inputtext: '',
      overall_coupon_selected: false,
      isCouponSearching: false,
      coupon: null,
      couponlistkey: null,
    };
  }

  removeFromCart = () => {
    this.props.removeFromCart(this.state);
  };

  searchCoupon = () => {
    if (!document.getElementById('coupon-id').value) {
      // this.setState({
      // 	error:'Please enter a valid coupon',
      // });
      return;
    }
    this.setState({
      coupons: [],
      isCouponSearching: true,
    });

    fetch(api_url + '/get_coupons', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: localStorage.myaddress
          ? JSON.parse(localStorage.myaddress).email
          : '',
        key: document.getElementById('coupon-id').value,
        keyword: document.getElementById('coupon-id').value,
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        var flag;
        var _finalcoupons = [];
        var _items = Object.keys(CartService.getCart());
        var _fullitems = CartService.getCart();
        if (_buyNow) {
          var index = _buyNowDetails.type + '_' + _buyNowDetails.id;
          var cart = {};
          cart[index] = _buyNowDetails;
          _items = Object.keys(cart);
          _fullitems = cart;
        }
        _items.map((key, item) => {
          _items[item] = key.replace('booking_event_', 'training_event_');
        });
        if (result.length) {
          result.map((key, res) => {
            if (key.pc_coupon_type == 1 && key.pc_customized_data) {
              var found = 0;
              _items.map((_item_key, item) => {
                if (
                  key.pc_customized_data.search(_item_key) != -1 &&
                  found == 0
                ) {
                  found = 1;
                }

                var temp_key = _item_key.replace(
                  'training_event_',
                  'booking_event_'
                );
                if (_fullitems[temp_key].type == 'booking_event') {
                  if (
                    key.pc_customized_data.search(
                      'training_course_' + _fullitems[temp_key].course_id
                    ) != -1 &&
                    found == 0
                  ) {
                    found = 1;
                  }
                }
              });
              if (found == 0) {
                // result.splice(res, 1);
                delete result[res];
              }
            }
          });
        }

        this.setState({
          coupon: result.length > 1 ? [] : result,
          coupons: result,
          couponlistkey: Math.random(),
          error:
            result.length == 0 || result[0] == undefined
              ? 'Coupon not found'
              : '',
          isCouponSearching: false,
        });
      })
      .catch();
  };

  selectCoupon = (item) => {
    _couponApplied.slug = 'coupon_' + item.id;
    _couponApplied.code = item.pc_code;
    _couponApplied.data = item;
    this.setState({
      selected_coupons: 'coupon_' + item.id,
      couponlistkey: Math.random(),
      overall_coupon_selected: true,
    });
  };

  dismiss = () => {
    document.body.className = document.body.className.replace(
      'disable_background_scroll',
      ''
    );

    _couponApplied.slug = '';
    _couponApplied.code = '';
    _couponApplied.data = null;
    this.setState({
      selected_coupons: '',
      // couponlistkey:Math.random()
    });
    // this.props.couponappliedtrigger();
    this.props.cb_dismiss();
  };

  applyCoupon = () => {
    document.body.className = document.body.className.replace(
      'disable_background_scroll',
      ''
    );
    if(_bfo == 0 && _couponApplied.data.pc_coupon_option == 1){
      this.setState({error : "Membership only coupon"});
      return;
    }
    CartService.getCouponRemaining(_couponApplied.data.id).then((res) => {
      this.setState({
        checkoutState: res.coupon_remaining
      });

      this.state.checkoutState = res.coupon_remaining;
    });
    this.props.applyCoupon();
  };

  selectedFromList = () => {
    this.setState({
      selected_coupons: '',
      overall_coupon_selected: true,
    });
  };

  updateInput = (event) => {
    this.setState({ inputtext: event.target.value });
  };

  render() {
    const { id, name, price, discount_price, type, desc, img } = this.state;
    var inputtext = this.state.inputtext;
    var item = null;

    if (this.state.coupon && this.state.coupon[0] != undefined) {
      item = this.state.coupon[0];
    }
    var selected = false;
    if (item) {
      if (
        this.state.selected_coupons &&
        this.state.selected_coupons == 'coupon_' + item.id
      ) {
        selected = true;
      }
      if (
        this.state.overall_coupon_selected &&
        _couponApplied.slug == 'coupon_' + item.id
      ) {
        selected = true;
      }
    }
    
    return (
      <div
        className="modal show fade in"
        id="coupon-sec"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="coupon-section">
          <div className="coupon-section-hdr-sec">
            <button
              type="button"
              className="close cart-close"
              onClick={this.dismiss}
            >
              ×
            </button>
            <h5>Coupons</h5>
            <span className="coupon-subtxt">Apply Coupon</span>
            <div className="form-group">
              <input
                //  onKeyUp={this.searchCoupon}
                onChange={this.updateInput}
                type="text"
                id="coupon-id"
                className={
                  'form-control ' + (this.state.error ? 'background-error' : '')
                }
                placeholder="Enter Coupon Code"
                required
              />
              <span
                className={'check-text' + (inputtext == '' ? '' : ' opaque')}
                onClick={this.searchCoupon}
              >
                Check
              </span>
              {this.state.error ? (
                <span
                  className="error-msg "
                  style={{ visibility: 'visible' }}
                  id="email_message_holder"
                >
                  <span className="error-msg-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16.4"
                      height="16.4"
                      viewBox="0 0 16.4 16.4"
                    >
                      <circle
                        id="Ellipse_63"
                        data-name="Ellipse 63"
                        cx="7.5"
                        cy="7.5"
                        r="7.5"
                        transform="translate(0.7 0.7)"
                        fill="#fff"
                        stroke="#e30002"
                        stroke-width="1.4"
                      ></circle>
                      <path
                        id="Path_59"
                        data-name="Path 59"
                        d="M822.5,583.685v4.54"
                        transform="translate(-814.216 -579.681)"
                        fill="none"
                        stroke="#e30002"
                        stroke-linecap="round"
                        stroke-width="2"
                      ></path>
                      <path
                        id="Path_60"
                        data-name="Path 60"
                        d="M822.5,583.725v-.04"
                        transform="translate(-814.216 -572.248)"
                        fill="none"
                        stroke="#e30002"
                        stroke-linecap="round"
                        stroke-width="2.4"
                      ></path>
                    </svg>
                  </span>
                  {this.state.error}
                </span>
              ) : (
                <div></div>
              )}
            </div>
            {item ? (
              <div
                key={item.id}
                className={'coupon-box mb-1' + (selected ? '  active' : ' ')}
              >
                <div className="d-flex justify-between align-items-baseline sm-d-block">
                  <div className="available_coupon_info_sec">
                    <div className="apply-coupon-box ml-0">{item.pc_code}</div>
                    <div className="coupon-subtxt mt10">{item.pc_name}</div>
                    {/* <div className="coupon-subtxt mt10">Get {item.pc_discount_type == 1? current_currency+item.pc_discount_rate:item.pc_discount_rate+'%'} cash back using this code</div> */}
                    <p>
                      {/* {item.pc_discount_type == 0? (item.pc_maximum_discount?" Maximum discount : "+current_currency+item.pc_maximum_discount:''):''} */}
                    </p>
                    <p>
                      {item.pc_description}
                      {/* Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia */}
                    </p>
                  </div>
                  {!selected ? (
                    <div
                      className="add-coupon"
                      onClick={() => this.selectCoupon(item)}
                    >
                      <svg
                        id="Group_2"
                        data-name="Group 2"
                        xmlns="http://www.w3.org/2000/svg"
                        width="11.855"
                        height="11.855"
                        viewBox="0 0 11.855 11.855"
                      >
                        <path
                          id="Path_16"
                          data-name="Path 16"
                          d="M3214,485.6v11.855"
                          transform="translate(-3208.073 -485.596)"
                          fill="none"
                          stroke="#2d71fd"
                          strokeWidth={2}
                        />
                        <path
                          id="Path_17"
                          data-name="Path 17"
                          d="M0,0V11.855"
                          transform="translate(11.855 5.928) rotate(90)"
                          fill="none"
                          stroke="#2d71fd"
                          strokeWidth={2}
                        />
                      </svg>
                      Add Coupon
                    </div>
                  ) : (
                    <div className="applied-coupon">
                      <div className="coupon-tick">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10.866"
                          height="8.349"
                          viewBox="0 0 10.866 8.349"
                        >
                          <g
                            id="Group_285"
                            data-name="Group 285"
                            transform="translate(-2954.033 -3898.327)"
                          >
                            <path
                              id="Path_42"
                              data-name="Path 42"
                              d="M39.616,14.176a.612.612,0,0,0-.866,0l-5.69,5.69L31.044,17.85a.613.613,0,1,0-.866.866l2.449,2.449a.612.612,0,0,0,.866,0l6.123-6.123a.612.612,0,0,0,0-.866Z"
                              transform="translate(2924.603 3884.83)"
                              fill="#fff"
                              stroke="#fff"
                              strokeWidth={1}
                            />
                          </g>
                        </svg>
                      </div>
                      Coupon Applied
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div></div>
            )}
          </div>

          <div className="coupon-brdr" />
          <CouponList
            global_coupon={this.props.global_coupon}
            key={this.state.couponlistkey}
            selectedFromList={this.selectedFromList}
            list={this.state.coupons}
            selected={this.state.selected_coupons}
          />
          <div className="coupon-brdr-btm mb-10" />
          <div className="align-center d-flex justify-between pr-15 pl-15">
            <div className="coupon-ftr-txt">
              Only one coupon is valid on each order.
            </div>
            <div
              disabled={!this.state.overall_coupon_selected ? 'disabled' : ''}
              onClick={
                !this.state.overall_coupon_selected ? null : this.applyCoupon
              }
              className="btn apply-cart-btn theme-blue-btn1 orange-flat-btn mr-0"
            >
              Apply Coupon
            </div>
          </div>
        </div>
      </div>
    );
  }
}
class CouponList extends React.Component {
  constructor(props) {
    super(props);
    var coupons = this.props.list ? this.props.list : [];
    var coupons_count = Object.keys(coupons).length;
    this.state = {
      selected_coupons: _couponApplied.slug,
      isprivateselected: this.props.selected,
      coupons: coupons,
      coupons_length: coupons_count,
      isloadingcoupons: true,
    };
  }

  findInstring() { }

  componentDidMount() {
    fetch(api_url + '/get_coupons', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: localStorage.myaddress
          ? JSON.parse(localStorage.myaddress).email
          : '',
      }),
    })
      .then((res) => res.json())
      .then((result) => {
        var _finalcoupons = [];
        var _items = Object.keys(CartService.getCart());
        var _fullitems = CartService.getCart();

        if (_buyNow) {
          var index = _buyNowDetails.type + '_' + _buyNowDetails.id;
          var cart = {};
          cart[index] = _buyNowDetails;
          _items = Object.keys(cart);
          _fullitems = cart;
        }

        _items.map((key, item) => {
          _items[item] = key.replace('booking_event_', 'training_event_');
        });

        var filter_coupons = [];
        result.map((key, res) => {

          if (key.pc_status == 1)
          {
            // GLOBAL COUPON SETTING CHECK
            if (this.props.global_coupon == 0)
            {
              // COUPON LIST FOR NON MEMBERS ONLY
              if (key.pc_coupon_option == 0) 
              {
                if (key.pc_coupon_type == 1 && key.pc_customized_data) 
                {
                  var found = 0;
                  _items.map((_item_key, item) => {
                    if (key.pc_customized_data.search(_item_key) != -1 && found == 0) {
                      found = 1;
                    }
                    var temp_key = _item_key.replace(
                      'training_event_',
                      'booking_event_'
                    );

                    if (_fullitems[temp_key].type == 'booking_event') {
                      if (
                        key.pc_customized_data.search(
                          'training_course_' + _fullitems[temp_key].course_id
                        ) != -1 &&
                        found == 0
                      ) {
                        found = 1;
                      }
                    }
                  });
                  if (found == 0) {
                    // result.splice(res, 1);
                    delete result[res];
                  }
                }
              } else {
                delete result[res];
              }
            } else if (this.props.global_coupon == 1) {
              // COUPON LIST FOR NON MEMBERS AND MEMBERS AND ALL PLATFORM
              if (key.pc_coupon_type == 1 && key.pc_customized_data) 
              {
                var found = 0;
                _items.map((_item_key, item) => {

                  if (key.pc_customized_data.search(_item_key) != -1 && found == 0) {
                    found = 1;
                  }
                  var temp_key = _item_key.replace(
                    'training_event_',
                    'booking_event_'
                  );

                  if (_fullitems[temp_key].type == 'booking_event') {
                    if (
                      key.pc_customized_data.search(
                        'training_course_' + _fullitems[temp_key].course_id
                      ) != -1 &&
                      found == 0
                    ) {
                      found = 1;
                    }
                  }
                });
                if (found == 0) {
                  // result.splice(res, 1);
                  delete result[res];
                }
              }
            }
          }
        });
        var test = result;
        this.setState({
          selected_coupons: _couponApplied.slug,
          coupons: result,
          coupons_length: Object.keys(result).length,
          isloadingcoupons: false,
        });
      })
      .catch();
  }

  selectCoupon = (item) => {
    // if(!this.state.isprivateselected && this.state.isprivateselected ==undefined){
    _couponApplied.slug = 'coupon_' + item.id;
    _couponApplied.code = item.pc_code;
    _couponApplied.data = item;
    this.setState({
      selected_coupons: 'coupon_' + item.id,
    });
    this.props.selectedFromList();
    // }
  };

  render() {
    return (
      <div>
        <span className="coupon-subtxt mt-15 mb-8">
          Available Coupons ({this.state.coupons_length})
        </span>
        <div className="coupon-info">
          {this.state.isloadingcoupons ? (
            <div>
              <span
                className="coupon-subtxt mt-15 eloads"
                style={{ height: 22, width: 140 }}
              />
              <div
                className="coupon-box mb-1"
                style={{ border: '1px solid #CCCCCC63' }}
              >
                <div className="align-center d-flex justify-content-between">
                  <div
                    style={{ height: 35, width: 100 }}
                    className=" ml-0 eloads"
                  />
                  <div style={{ width: 90, height: 25 }} className="eloads" />
                </div>
                <div
                  style={{ width: 380, height: 20 }}
                  className="eloads mt10"
                />
                <p
                  className="eloads"
                  style={{
                    height: 10,
                    width: 378,
                    marginTop: 5,
                    marginBottom: 0,
                  }}
                />
                <p
                  className="eloads"
                  style={{ height: 10, width: 240, marginTop: 5 }}
                />
              </div>
              <div
                className="coupon-box mb-1"
                style={{ border: '1px solid #CCCCCC63' }}
              >
                <div className="align-center d-flex justify-content-between">
                  <div
                    style={{ height: 35, width: 100 }}
                    className=" ml-0 eloads"
                  />
                  <div style={{ width: 90, height: 25 }} className="eloads" />
                </div>
                <div
                  style={{ width: 380, height: 20 }}
                  className="eloads mt10"
                />
                <p
                  className="eloads"
                  style={{
                    height: 10,
                    width: 378,
                    marginTop: 5,
                    marginBottom: 0,
                  }}
                />
                <p
                  className="eloads"
                  style={{ height: 10, width: 240, marginTop: 5 }}
                />
              </div>
              <div
                className="coupon-box mb-1"
                style={{ border: '1px solid #CCCCCC63' }}
              >
                <div className="align-center d-flex justify-content-between">
                  <div
                    style={{ height: 35, width: 100 }}
                    className=" ml-0 eloads"
                  />
                  <div style={{ width: 90, height: 25 }} className="eloads" />
                </div>
                <div
                  style={{ width: 380, height: 20 }}
                  className="eloads mt10"
                />
                <p
                  className="eloads"
                  style={{
                    height: 10,
                    width: 378,
                    marginTop: 5,
                    marginBottom: 0,
                  }}
                />
                <p
                  className="eloads"
                  style={{ height: 10, width: 240, marginTop: 5 }}
                />
              </div>
            </div>
          ) : this.state.coupons_length != 0 ? (
            <div>
              {this.state.coupons.map((item, index) => {
                var selected = false;
                if (
                  this.state.selected_coupons &&
                  this.state.selected_coupons == 'coupon_' + item.id
                ) {
                  selected = true;
                }
                if (item.pc_visibility == '1') return <div></div>;
                {
                  /* && item.pc_visibility =='0' */
                }

                return (
                  <div
                    key={item.id}
                    className={'coupon-box mb-1' + (selected ? ' active' : '')}
                  >
                    <div className="d-flex justify-between align-items-baseline sm-d-block">
                      <div className="available_coupon_info_sec">
                        <div className="apply-coupon-box ml-0">
                          {item.pc_code}
                        </div>
                        <div className="coupon-subtxt mt10">{item.pc_name}</div>
                        {/* <div className="coupon-subtxt mt10">Get {item.pc_discount_type == 1? current_currency+item.pc_discount_rate:item.pc_discount_rate+'%'} cash back using this code</div> */}
                        <p>
                          {/* {item.pc_discount_type == 0? (item.pc_maximum_discount?" Maximum discount : "+current_currency+item.pc_maximum_discount:''):''} */}
                        </p>
                        <p>
                          {item.pc_description}
                          {/* Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia */}
                        </p>
                      </div>
                      {!selected ? (
                        <div
                          className="add-coupon"
                          onClick={() => this.selectCoupon(item)}
                        >
                          <svg
                            id="Group_2"
                            data-name="Group 2"
                            xmlns="http://www.w3.org/2000/svg"
                            width="11.855"
                            height="11.855"
                            viewBox="0 0 11.855 11.855"
                          >
                            <path
                              id="Path_16"
                              data-name="Path 16"
                              d="M3214,485.6v11.855"
                              transform="translate(-3208.073 -485.596)"
                              fill="none"
                              stroke="#2d71fd"
                              strokeWidth={2}
                            />
                            <path
                              id="Path_17"
                              data-name="Path 17"
                              d="M0,0V11.855"
                              transform="translate(11.855 5.928) rotate(90)"
                              fill="none"
                              stroke="#2d71fd"
                              strokeWidth={2}
                            />
                          </svg>
                          Add Coupon
                        </div>
                      ) : (
                        <div className="applied-coupon">
                          <div className="coupon-tick">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10.866"
                              height="8.349"
                              viewBox="0 0 10.866 8.349"
                            >
                              <g
                                id="Group_285"
                                data-name="Group 285"
                                transform="translate(-2954.033 -3898.327)"
                              >
                                <path
                                  id="Path_42"
                                  data-name="Path 42"
                                  d="M39.616,14.176a.612.612,0,0,0-.866,0l-5.69,5.69L31.044,17.85a.613.613,0,1,0-.866.866l2.449,2.449a.612.612,0,0,0,.866,0l6.123-6.123a.612.612,0,0,0,0-.866Z"
                                  transform="translate(2924.603 3884.83)"
                                  fill="#fff"
                                  stroke="#fff"
                                  strokeWidth={1}
                                />
                              </g>
                            </svg>
                          </div>
                          Coupon Applied
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div>
              <div className="coupon-subtxt  no-coupon-txt">
                No other coupons available.
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export class PpsModal extends React.Component {
  constructor(props) {
    super(props);
    document.body.className += ' disable_background_scroll';
    this.state = {
      hasPPS: true,
      ppsData: {},
      proccessBtnDisable: true,
      fieldPpsError: false,
      fieldNameError: false,
      fieldDobError: false,
      fieldCountryError: false,
      fieldInsuranceError: false,
      fieldAddressError: false,
      fieldContractorNameError: false,
      fieldContractorEmailError: false,
      fieldContractorAddressError: false,
      fieldContractorLocationError: false,
      ppsFormErrorCount: 0,
      countries: [],
    };
  }

  validation = (param) => {
    let input = param.value;
    let field = param.field;
    let stateIndex = param.stateIndex;
    let type = param.type;
    let errorText = 'ok';
    let error = 0;
    let ppsIndex = param.ppsIndex;
    if (type) {
      for (let index = 0; index < type.length; index++) {
        let validationType = type[index];
        if (validationType == 'requird') {
          if (input == '') {
            errorText = `${field} is Required`;
            error++;
            break;
          }
        } else if (validationType == 'number') {
          let regex = new RegExp('^[0-9]+$');
          if (!regex.test(input)) {
            errorText = `${field} is Must be Number`;
            error++;
            break;
          }
        } else if (validationType == 'email') {
          let regex = new RegExp(
            /\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/
          );
          if (!regex.test(input)) {
            errorText = `${field} is not a valid email`;
            error++;
            break;
          }
        }
      }
    }

    let errorMsg = ``;
    let newStateData = {};
    newStateData[stateIndex] = errorText;
    let ppdata = this.state.ppsData;

    // number only regx
    if (ppsIndex == 'nationalInsuranceNumber') {
      const re = /^[0-9\b]+$/;
      if (re.test(input) || input == '') {
        ppdata[ppsIndex] = input;
      }
    } else {
      ppdata[ppsIndex] = input;
    }
    newStateData['ppsData'] = ppdata;

    if (newStateData['ppsData']) {
      if (this.state.hasPPS && ppsIndex == 'ppsNumber') {
        if (error == 0) {
          newStateData['proccessBtnDisable'] = false;
        } else {
          newStateData['proccessBtnDisable'] = true;
        }
      }
    }

    if (ppsIndex != 'ppsNumber') {
      let {
        fieldNameError,
        fieldDobError,
        fieldCountryError,
        fieldInsuranceError,
        fieldAddressError,
        fieldContractorNameError,
        fieldContractorEmailError,
        fieldContractorAddressError,
        fieldContractorLocationError,
      } = this.state;

      let ppsformError = {
        fieldNameError,
        fieldDobError,
        fieldCountryError,
        fieldInsuranceError,
        fieldAddressError,
        fieldContractorNameError,
        fieldContractorEmailError,
        fieldContractorAddressError,
        fieldContractorLocationError,
      };

      ppsformError[stateIndex] = errorText;

      let ppsFormErrorFlag =
        ppsformError['fieldNameError'] == 'ok' &&
        ppsformError['fieldDobError'] == 'ok' &&
        ppsformError['fieldCountryError'] == 'ok' &&
        ppsformError['fieldInsuranceError'] == 'ok' &&
        ppsformError['fieldAddressError'] == 'ok' &&
        ppsformError['fieldContractorNameError'] == 'ok' &&
        ppsformError['fieldContractorEmailError'] == 'ok' &&
        ppsformError['fieldContractorAddressError'] == 'ok' &&
        ppsformError['fieldContractorLocationError'] == 'ok';

      if (ppsFormErrorFlag) {
        newStateData['proccessBtnDisable'] = false;
      } else {
        newStateData['proccessBtnDisable'] = true;
      }
    }

    this.setState(newStateData);
  };

  componentDidMount() {
    // fetch(__siteUrl + "/mykademy/api/v1/countries", {
    // 	method: "GET",
    // 	headers: {
    // 		Accept: "application/json",
    // 		"Content-Type": "application/json",
    // 	},
    // })
    // 	.then((res) => res.json())
    // 	.then((result) => {
    // 		this.setState({ countries: result.data });
    // 	});
    this.setState({
      countries: JSON.parse(
        localStorage.getItem('countries')
          ? localStorage.getItem('countries')
          : '[]'
      ),
    });
    // this.setState({ countries: JSON.parse(localStorage.getItem('countries')?localStorage.getItem('countries'):'[]')});
  }

  ppsSkip = (el) => {
    // this.setState({...this.state.ppsData,'hasPPS':false});
    document.getElementById('ppsFormData').submit();
  };

  ppsShowHide = (hasPPS) => {
    let newStateData = {};
    if (hasPPS) {
      newStateData['proccessBtnDisable'] = !(this.state.fieldPpsError == 'ok');
    } else {
      let ppsFormErrorFlag =
        this.state.fieldNameError == 'ok' &&
        this.state.fieldDobError == 'ok' &&
        this.state.fieldCountryError == 'ok' &&
        this.state.fieldInsuranceError == 'ok' &&
        this.state.fieldAddressError == 'ok' &&
        this.state.fieldContractorNameError == 'ok' &&
        this.state.fieldContractorEmailError == 'ok' &&
        this.state.fieldContractorAddressError == 'ok' &&
        this.state.fieldContractorLocationError == 'ok';

      newStateData['proccessBtnDisable'] = !ppsFormErrorFlag;
    }

    newStateData['hasPPS'] = hasPPS;
    this.setState(newStateData);
  };

  render() {
    return (
      <div
        className="modal show fade in"
        id="details-pps"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="pps-details-sec">
          <button
            type="button"
            className="close cart-close"
            onClick={this.props.closeCallBack}
          >
            ×
          </button>
          <h5 className="mt-0">Details</h5>
          <p className="pr-4">
            Personal Public Service Number (PPSN) is a unique reference number
            given by the Department of Social Protection, which is needed for
            all dealings with public service agencies.
          </p>
          <span className="coupon-subtxt">
            Do you have a {this.props.govtIdCardLablel} number?
          </span>
          <div className="d-flex mt8 ppc-choose">
            <form action="#">
              <span>
                <input
                  type="radio"
                  id="yes"
                  name="radio-group"
                  defaultChecked
                  onClick={() => this.ppsShowHide(true)}
                />
                <label htmlFor="yes">Yes</label>
              </span>
              <span className="no-ppc-sec">
                <input
                  type="radio"
                  id="no"
                  name="radio-group"
                  onClick={() => this.ppsShowHide(false)}
                />
                <label htmlFor="no">No</label>
              </span>
            </form>
          </div>
          <form
            action={`${siteUrl}cart_react/store`}
            method="post"
            id="ppsFormData"
          >
            {this.state.hasPPS && (
              <div className="pps-member-sec">
                <div className="form-group mt-2">
                  <input
                    type="text"
                    id="pps-number"
                    required="true"
                    className={`form-control ${this.state.fieldPpsError != false &&
                      this.state.fieldPpsError != 'ok' &&
                      'border-error background-error'
                      }`}
                    value={
                      this.state.ppsData.ppsNumber
                        ? this.state.ppsData.ppsNumber
                        : ''
                    }
                    onChange={(e) =>
                      this.validation({
                        ppsIndex: 'ppsNumber',
                        value: e.target.value,
                        stateIndex: 'fieldPpsError',
                        field: 'PPS number',
                        type: ['requird', 'number'],
                      })
                    }
                  />
                  <label
                    className={`form-control-placeholder ${this.state.fieldPpsError != false &&
                      this.state.fieldPpsError != 'ok' &&
                      'color-error'
                      }`}
                    htmlFor="pps-number"
                  >
                    Enter PPS Number
                  </label>
                  {this.state.fieldPpsError != false &&
                    this.state.fieldPpsError != 'ok' && (
                      <InputError error={this.state.fieldPpsError} />
                    )}
                </div>
                <p className="mb-158">
                  Please add your Unique Identification Number that helps us in
                  authenticating you.{' '}
                </p>
              </div>
            )}

            {!this.state.hasPPS && (
              <div className="pps-no-member-sec mt-05">
                <span className="coupon-subtxt">Enter STB Form</span>
                <span className="cart-sub-text">Candidate Details</span>
                <div className="row">
                  <div className="col-md-6 pr-1 pr-sm-15">
                    <div className="form-group">
                      <input
                        type="text"
                        id="full-name"
                        className={`form-control ${this.state.fieldNameError != false &&
                          this.state.fieldNameError != 'ok' &&
                          'border-error background-error'
                          }`}
                        value={
                          this.state.ppsData.fullName
                            ? this.state.ppsData.fullName
                            : ''
                        }
                        required
                        onChange={(e) =>
                          this.validation({
                            ppsIndex: 'fullName',
                            value: e.target.value,
                            stateIndex: 'fieldNameError',
                            field: 'First and Last Name',
                            type: ['requird'],
                          })
                        }
                      />
                      <label
                        className={`form-control-placeholder ${this.state.fieldNameError != false &&
                          this.state.fieldNameError != 'ok' &&
                          'color-error'
                          }`}
                        htmlFor="full-name" style={{'text-transform': 'none'}}
                      >
                        First and Last Name
                      </label>
                      {this.state.fieldNameError != false &&
                        this.state.fieldNameError != 'ok' && (
                          <InputError error={this.state.fieldNameError} />
                        )}
                    </div>
                  </div>
                  <div className="col-md-6 pl-1 pd-sm">
                    <div className="form-group">
                      <input
                        type="date"
                        id="date"
                        className={`form-control ${this.state.fieldDobError != false &&
                          this.state.fieldDobError != 'ok' &&
                          'border-error background-error'
                          }`}
                        required
                        value={
                          this.state.ppsData.DOB ? this.state.ppsData.DOB : ''
                        }
                        onChange={(e) =>
                          this.validation({
                            ppsIndex: 'DOB',
                            value: e.target.value,
                            stateIndex: 'fieldDobError',
                            field: 'DOB',
                            type: ['requird'],
                          })
                        }
                      />
                      <label
                        className={`form-control-placeholder date-label ${this.state.fieldDobError != false &&
                          this.state.fieldDobError != 'ok' &&
                          'color-error'
                          }`}
                        htmlFor="date"
                      >
                        DOB
                      </label>
                      {this.state.fieldDobError != false &&
                        this.state.fieldDobError != 'ok' && (
                          <InputError error={this.state.fieldDobError} />
                        )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 pr-1 pr-sm-15">
                    {/* <div className="form-group">
						<input type="country" id="country" className={`form-control ${(this.state.fieldCountryError !=false && this.state.fieldCountryError != 'ok') && 'border-error background-error'}`} required value={this.state.ppsData.country?this.state.ppsData.country:''} onChange={(e)=>this.validation({'ppsIndex':'country','value':e.target.value,'stateIndex':'fieldCountryError','field':'Country','type':['requird']})} />
						<label className={`form-control-placeholder ${(this.state.fieldCountryError !=false && this.state.fieldCountryError != 'ok') && 'color-error'}`} htmlFor="country">Country</label>
						{ (this.state.fieldCountryError != false && this.state.fieldCountryError != 'ok') && <InputError error={this.state.fieldCountryError}/>}
					
					  </div> */}

                    <div className="form-group country-code">
                      <label
                        className={`control-label country-code-info ${this.state.fieldCountryError != false &&
                          this.state.fieldCountryError != 'ok' &&
                          'color-error'
                          }`}
                        htmlFor="country"
                      >
                        Country
                      </label>
                      <select
                        type="country"
                        name="country"
                        id="country"
                        className={`form-control ${this.state.fieldCountryError != false &&
                          this.state.fieldCountryError != 'ok' &&
                          'border-error background-error'
                          }`}
                        required
                        value={
                          this.state.ppsData.country
                            ? this.state.ppsData.country
                            : ''
                        }
                        onChange={(e) =>
                          this.validation({
                            ppsIndex: 'country',
                            value: e.target.value,
                            stateIndex: 'fieldCountryError',
                            field: 'Country',
                            type: ['requird'],
                          })
                        }
                      >
                        <option value="">Select a country</option>
                        {this.state.countries.map((item, i) => {
                          return (
                            <option value={item.country_name}>
                              {item.country_name}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6 pl-1 pd-sm">
                    <div className="form-group">
                      <input
                        type="text"
                        pattern="[0-9]*"
                        id="insurance-num"
                        className={`form-control ${this.state.fieldInsuranceError != false &&
                          this.state.fieldInsuranceError != 'ok' &&
                          'border-error background-error'
                          }`}
                        required
                        value={
                          this.state.ppsData.nationalInsuranceNumber
                            ? this.state.ppsData.nationalInsuranceNumber
                            : ''
                        }
                        onChange={(e) =>
                          this.validation({
                            ppsIndex: 'nationalInsuranceNumber',
                            value: e.target.value,
                            stateIndex: 'fieldInsuranceError',
                            field: 'National Insurance Number',
                            type: ['requird'],
                          })
                        }
                      />
                      <label
                        className={`form-control-placeholder ${this.state.fieldInsuranceError != false &&
                          this.state.fieldInsuranceError != 'ok' &&
                          'color-error'
                          }`}
                        htmlFor="insurance-num"
                      >
                        National Insurance Number
                      </label>
                      {this.state.fieldInsuranceError != false &&
                        this.state.fieldInsuranceError != 'ok' && (
                          <InputError error={this.state.fieldInsuranceError} />
                        )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        id="address"
                        className={`form-control ${this.state.fieldAddressError != false &&
                          this.state.fieldAddressError != 'ok' &&
                          'border-error background-error'
                          }`}
                        value={
                          this.state.ppsData.address
                            ? this.state.ppsData.address
                            : ''
                        }
                        required
                        onChange={(e) =>
                          this.validation({
                            ppsIndex: 'address',
                            value: e.target.value,
                            stateIndex: 'fieldAddressError',
                            field: 'Address',
                            type: ['requird'],
                          })
                        }
                      />
                      <label
                        className={`form-control-placeholder ${this.state.fieldAddressError != false &&
                          this.state.fieldAddressError != 'ok' &&
                          'color-error'
                          }`}
                        htmlFor="address"
                      >
                        Address
                      </label>
                      {this.state.fieldAddressError != false &&
                        this.state.fieldAddressError != 'ok' && (
                          <InputError error={this.state.fieldAddressError} />
                        )}
                    </div>
                  </div>
                </div>
                <span className="cart-sub-text">Contractor Details</span>
                <div className="row">
                  <div className="col-md-6 pr-1 pr-sm-15">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name-id"
                        className={`form-control ${this.state.fieldContractorNameError != false &&
                          this.state.fieldContractorNameError != 'ok' &&
                          'border-error background-error'
                          }`}
                        value={
                          this.state.ppsData.contractorFullName
                            ? this.state.ppsData.contractorFullName
                            : ''
                        }
                        required
                        onChange={(e) =>
                          this.validation({
                            ppsIndex: 'contractorFullName',
                            value: e.target.value,
                            stateIndex: 'fieldContractorNameError',
                            field: 'First and Last Name',
                            type: ['requird'],
                          })
                        }
                      />
                      <label
                        className={`form-control-placeholder ${this.state.fieldContractorNameError != false &&
                          this.state.fieldContractorNameError != 'ok' &&
                          'color-error'
                          }`}
                        htmlFor="name-id" style={{'text-transform': 'none'}}
                      >
                        First and Last Name
                      </label>
                      {this.state.fieldContractorNameError != false &&
                        this.state.fieldContractorNameError != 'ok' && (
                          <InputError
                            error={this.state.fieldContractorNameError}
                          />
                        )}
                    </div>
                  </div>
                  <div className="col-md-6 pl-1 pd-sm">
                    <div className="form-group">
                      <input
                        type="text"
                        id="email-id"
                        className={`form-control ${this.state.fieldContractorEmailError != false &&
                          this.state.fieldContractorEmailError != 'ok' &&
                          'border-error background-error'
                          }`}
                        value={
                          this.state.ppsData.contractorEmail
                            ? this.state.ppsData.contractorEmail
                            : ''
                        }
                        required
                        onChange={(e) =>
                          this.validation({
                            ppsIndex: 'contractorEmail',
                            value: e.target.value,
                            stateIndex: 'fieldContractorEmailError',
                            field: 'Email Address',
                            type: ['requird', 'email'],
                          })
                        }
                      />
                      <label
                        className={`form-control-placeholder ${this.state.fieldContractorEmailError != false &&
                          this.state.fieldContractorEmailError != 'ok' &&
                          'color-error'
                          }`}
                        htmlFor="email-id"
                      >
                        Email Address
                      </label>
                      {this.state.fieldContractorEmailError != false &&
                        this.state.fieldContractorEmailError != 'ok' && (
                          <InputError
                            error={this.state.fieldContractorEmailError}
                          />
                        )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        id="pps-address"
                        className={`form-control ${this.state.fieldContractorAddressError != false &&
                          this.state.fieldContractorAddressError != 'ok' &&
                          'border-error background-error'
                          }`}
                        value={
                          this.state.ppsData.contractorAddress
                            ? this.state.ppsData.contractorAddress
                            : ''
                        }
                        required
                        onChange={(e) =>
                          this.validation({
                            ppsIndex: 'contractorAddress',
                            value: e.target.value,
                            stateIndex: 'fieldContractorAddressError',
                            field: 'Address',
                            type: ['requird'],
                          })
                        }
                      />
                      <label
                        className={`form-control-placeholder ${this.state.fieldContractorAddressError != false &&
                          this.state.fieldContractorAddressError != 'ok' &&
                          'color-error'
                          }`}
                        htmlFor="pps-address"
                      >
                        Address (in Ireland)
                      </label>
                      {this.state.fieldContractorAddressError != false &&
                        this.state.fieldContractorAddressError != 'ok' && (
                          <InputError
                            error={this.state.fieldContractorAddressError}
                          />
                        )}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="pps-location"
                        className={`form-control ${this.state.fieldContractorLocationError != false &&
                          this.state.fieldContractorLocationError != 'ok' &&
                          'border-error background-error'
                          }`}
                        value={
                          this.state.ppsData.siteLocation
                            ? this.state.ppsData.siteLocation
                            : ''
                        }
                        required
                        onChange={(e) =>
                          this.validation({
                            ppsIndex: 'siteLocation',
                            value: e.target.value,
                            stateIndex: 'fieldContractorLocationError',
                            field: 'Site Location',
                            type: ['requird'],
                          })
                        }
                      />
                      <label
                        className={`form-control-placeholder ${this.state.fieldContractorLocationError != false &&
                          this.state.fieldContractorLocationError != 'ok' &&
                          'color-error'
                          }`}
                        htmlFor="pps-location"
                      >
                        Site Location (in Ireland)
                      </label>
                      {this.state.fieldContractorLocationError != false &&
                        this.state.fieldContractorLocationError != 'ok' && (
                          <InputError
                            error={this.state.fieldContractorLocationError}
                          />
                        )}
                    </div>
                  </div>
                </div>
              </div>
            )}
            <input
              name="pps_form_data"
              type="hidden"
              value={JSON.stringify({
                ...this.state.ppsData,
                hasPPS: this.state.hasPPS,
              })}
            />
            <input name="buynow" type="hidden" value={_buyNow} />
            <input name="coupon" type="hidden" value={_couponApplied.slug} />
            <div className="brdrline"></div>
            <button
              className="btn cart-btn orange-flat-btn h-45 mt-2 theme-blue-btn1 w-75 mr-center-align"
              type="submit"
              disabled={this.state.proccessBtnDisable}
            >
              Proceed
            </button>
            {/* <button className="mt-25 skip-txt" onClick={()=>this.ppsSkip(true)}>Skip for now. Let’s do this later</button> */}
            <div className="mt-25 skip-txt" onClick={() => this.ppsSkip(true)}>
              Skip for now. Let’s do this later
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export class CartItemsValidate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div
        className="modal show fade in"
        id="item-verify"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="pps-details-sec">
          <h5 className="mt-0">
            Few items in your cart are currently unavailable
          </h5>
          <p className="pr-4">
            Proceed to checkout after removing unavailable items.
          </p>

          <div className="d-flex mt8 ppc-choose flex-column">
            {this.props.expiredCartItems.length > 0 &&
              this.props.expiredCartItems.map((item) => {
                return (
                  <div className="cart-box">
                    <div className="d-flex sm-d-block">
                      <div className="cart-img">
                        <img
                          src={item.others.image}
                          onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = default_img;
                          }}
                        />
                      </div>
                      <div className="cart-txtbar  justify-content-between">
                        <div className="cart-text">
                          {item.others.title && <h5>{item.others.title}</h5>}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
          {/* <button className="btn cart-btn h-45 mt-2 theme-blue-btn1 w-75 mr-center-align" onClick={this.props.ReviewedCartContinueCallBack}>Yes,Continue</button> */}

          <div className="mt-25 skip-txt" onClick={this.props.closeCallBack}>
            {' '}
            Review Cart
          </div>
        </div>
      </div>
    );
  }
}

export class CheckOutValidateModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = this.props.errorData;
  }
  // onClick={this.props.closeCallBack} removeCoupon
  closenandremove = () => {
    if (this.state.iscouponerror) {
      this.props.removeCoupon();
    }
    this.props.closeCallBack();
  };

  goToProfile = ()=>{
    window.location.href = "/dashboard/profile";
    return;
  }

  renderErrorModal = () => {
    let iscart = this.state.iscart;
    let error = this.state.data.item_error
      ? this.state.data.item_error
      : this.state.data.coupon_error ? this.state.data.coupon_error
      : this.state.data.bundle_error ? this.state.data.bundle_error : '';
    
    if(this.state.country_code_error){
      return  <div
      className="modal show fade in"
      id="item-verify"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="pps-details-sec">
        <h5 className="mt-0">Oops! Wrong country code</h5>
        <p>Please go to profile and update your country code.</p>

        <div className="d-flex mt-2 ppc-choose flex-column">
          {error.length > 0 &&
            error.map((item) => {
              return (
                <div className="cart-box">
                  <div className="d-flex">
                    <div className="cart-img">
                      <img
                        src={item.details.others.image}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = default_img;
                        }}
                      />
                    </div>
                    <div className="cart-txtbar  justify-content-between">
                      <div className="cart-text">
                        <span
                          className="sold_out_text"
                          title={item.message[1] ? item.message[1] : ''}
                        >
                          {item.message[0] && (
                            <span className="coupon-close">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="10.079"
                                height="10.061"
                                viewBox="0 0 10.079 10.061"
                              >
                                <g
                                  id="noun_Close_4046821"
                                  transform="translate(-3.489 -18.576)"
                                >
                                  <g
                                    id="Group_38"
                                    data-name="Group 38"
                                    transform="translate(4 19.076)"
                                  >
                                    <path
                                      id="Path_41"
                                      data-name="Path 41"
                                      d="M4.758,4a.754.754,0,0,0-.525,1.294l3.228,3.23L4.237,11.75A.753.753,0,1,0,5.3,12.816L8.526,9.589l3.224,3.226a.753.753,0,1,0,1.065-1.065L9.591,8.524l3.228-3.229a.754.754,0,1,0-1.065-1.066L8.526,7.459,5.3,4.229A.753.753,0,0,0,4.758,4Z"
                                      transform="translate(-4 -4)"
                                      fill="#76ad94"
                                      stroke="#76ad94"
                                      strokeWidth="1"
                                      fillRule="evenodd"
                                    ></path>
                                  </g>
                                </g>
                              </svg>
                            </span>
                          )}
                          {item.message[0]}
                        </span>
                        {item.details.others.title && (
                          <h5>{item.details.others.title}</h5>
                        )}

                        <div class="cart-bulk-actions bulk-learner-list">
                          {item.learners && item.learners.length && _bfo ? (
                            item.learners.map((learner) => {
                              var learners = CartService.getLearner(
                                item.item
                              );
                              return (
                                <div class="learner_lists">
                                  <span class="name-letter">
                                    {learners[learner].name
                                      .charAt(0)
                                      .toUpperCase()}
                                  </span>
                                  <span
                                    class="learner-name"
                                    title={learners[learner].name}
                                  >
                                    {learners[learner].name}
                                  </span>
                                  <span
                                    class="mail-id"
                                    title={learners[learner].email}
                                  >
                                    {learners[learner].email}
                                  </span>
                                </div>
                              );
                            })
                          ) : (
                            <div></div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>

        <div className="mt-25 skip-txt" onClick={this.goToProfile}>
          Go to profile
        </div>
      </div>
    </div>
    } else if(iscart && this.state.data.item_error){
      return   <div
      className="modal show fade in"
      id="item-verify"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="pps-details-sec">
        <h5 className="mt-0">Oops! Something went wrong</h5>
        <p>Proceed to checkout after removing unavailable items.</p>

        <div className="d-flex mt-2 ppc-choose flex-column">
          {error.length > 0 &&
            error.map((item) => {
              return (
                <div className="cart-box">
                  <div className="d-flex">
                    <div className="cart-img">
                      <img
                        src={item.details.others.image}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = default_img;
                        }}
                      />
                    </div>
                    <div className="cart-txtbar  justify-content-between">
                      <div className="cart-text">
                        <span
                          className="sold_out_text"
                          title={item.message[1] ? item.message[1] : ''}
                        >
                          {item.message[0] && (
                            <span className="coupon-close">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="10.079"
                                height="10.061"
                                viewBox="0 0 10.079 10.061"
                              >
                                <g
                                  id="noun_Close_4046821"
                                  transform="translate(-3.489 -18.576)"
                                >
                                  <g
                                    id="Group_38"
                                    data-name="Group 38"
                                    transform="translate(4 19.076)"
                                  >
                                    <path
                                      id="Path_41"
                                      data-name="Path 41"
                                      d="M4.758,4a.754.754,0,0,0-.525,1.294l3.228,3.23L4.237,11.75A.753.753,0,1,0,5.3,12.816L8.526,9.589l3.224,3.226a.753.753,0,1,0,1.065-1.065L9.591,8.524l3.228-3.229a.754.754,0,1,0-1.065-1.066L8.526,7.459,5.3,4.229A.753.753,0,0,0,4.758,4Z"
                                      transform="translate(-4 -4)"
                                      fill="#76ad94"
                                      stroke="#76ad94"
                                      strokeWidth="1"
                                      fillRule="evenodd"
                                    ></path>
                                  </g>
                                </g>
                              </svg>
                            </span>
                          )}
                          {item.message[0]}
                        </span>
                        {item.details.others.title && (
                          <h5>{item.details.others.title}</h5>
                        )}

                        <div class="cart-bulk-actions bulk-learner-list">
                          {item.learners && item.learners.length && _bfo ? (
                            item.learners.map((learner) => {
                              var learners = CartService.getLearner(
                                item.item
                              );
                              return (
                                <div class="learner_lists">
                                  <span class="name-letter">
                                    {learners[learner].name
                                      .charAt(0)
                                      .toUpperCase()}
                                  </span>
                                  <span
                                    class="learner-name"
                                    title={learners[learner].name}
                                  >
                                    {learners[learner].name}
                                  </span>
                                  <span
                                    class="mail-id"
                                    title={learners[learner].email}
                                  >
                                    {learners[learner].email}
                                  </span>
                                </div>
                              );
                            })
                          ) : (
                            <div></div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>

        <div className="mt-25 skip-txt" onClick={this.props.closeCallBack}>
             Review Cart
        </div>
      </div>
    </div>
    }else{
      return <div
      className="modal show fade in"
      id="courses"
      tabIndex={-1}
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      {/* sign in section start here */}
      <div className="course-wraper">
        {/* <button type="button" className="close cart-close" data-dismiss="modal">×</button> */}
        <div className="order-succes-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="82"
            height="82"
            viewBox="0 0 82 82"
          >
            <g
              id="Ellipse_107"
              data-name="Ellipse 107"
              transform="translate(10 10)"
              fill="#f58484"
              stroke="rgba(224,136,136,0.2)"
              strokeWidth="10"
            >
              <circle cx="31" cy="31" r="31" stroke="none" />
              <circle cx="31" cy="31" r="36" fill="none" />
            </g>
            <g
              id="Group_7"
              data-name="Group 7"
              transform="translate(2327.5 1155)"
            >
              <path
                id="Path_82"
                data-name="Path 82"
                d="M23071.385-21816.166l6.5-6.5,10.84-10.828"
                transform="translate(-25366.885 20710.992)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="5"
              />
              <path
                id="Path_82-2"
                data-name="Path 82"
                d="M23071.385-21816.166l6.5-6.5,10.84-10.828"
                transform="translate(-24111.666 -24193.885) rotate(90)"
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="5"
              />
            </g>
          </svg>
        </div>
        <h3 className="mt-1" id="subscription_succees_modal_type_text">
          {error[0] && error[0].message && error[0].message[0] ? error[0].message[0] : "" }
        </h3>
        {error[0] && error[0].message && error[0].message[1] ? (<p>{error[0].message[1]}</p>) : "" }
        <button
          className="btn mt-2 mt-3 front_end_cart_btn theme-blue-btn1 orange-flat-btn"
          id="item_enroll_success_btn"
          data-dismiss="modal"
          onClick={this.closenandremove}
        // onClick={this.props.closeCallBack} removeCouponclosenandremove
        >
          Okay
        </button>
      </div>
    </div>
    }
  }

  render() {
    let iscart = this.state.iscart;
    let error = this.state.data.item_error
      ? this.state.data.item_error
      : this.state.data.coupon_error ? this.state.data.coupon_error
      : this.state.data.bundle_error ? this.state.data.bundle_error : '';

    return this.renderErrorModal();

   
    // return iscart && this.state.data.item_error ? (
    //   <div
    //     className="modal show fade in"
    //     id="item-verify"
    //     tabIndex={-1}
    //     role="dialog"
    //     aria-labelledby="exampleModalLabel"
    //     aria-hidden="true"
    //   >
    //     <div className="pps-details-sec">
    //       <h5 className="mt-0">Oops! Something went wrong</h5>
    //       <p>Proceed to checkout after removing unavailable items.</p>

    //       <div className="d-flex mt-2 ppc-choose flex-column">
    //         {error.length > 0 &&
    //           error.map((item) => {
    //             return (
    //               <div className="cart-box">
    //                 <div className="d-flex">
    //                   <div className="cart-img">
    //                     <img
    //                       src={item.details.others.image}
    //                       onError={(e) => {
    //                         e.target.onerror = null;
    //                         e.target.src = default_img;
    //                       }}
    //                     />
    //                   </div>
    //                   <div className="cart-txtbar  justify-content-between">
    //                     <div className="cart-text">
    //                       <span
    //                         className="sold_out_text"
    //                         title={item.message[1] ? item.message[1] : ''}
    //                       >
    //                         {item.message[0] && (
    //                           <span className="coupon-close">
    //                             <svg
    //                               xmlns="http://www.w3.org/2000/svg"
    //                               width="10.079"
    //                               height="10.061"
    //                               viewBox="0 0 10.079 10.061"
    //                             >
    //                               <g
    //                                 id="noun_Close_4046821"
    //                                 transform="translate(-3.489 -18.576)"
    //                               >
    //                                 <g
    //                                   id="Group_38"
    //                                   data-name="Group 38"
    //                                   transform="translate(4 19.076)"
    //                                 >
    //                                   <path
    //                                     id="Path_41"
    //                                     data-name="Path 41"
    //                                     d="M4.758,4a.754.754,0,0,0-.525,1.294l3.228,3.23L4.237,11.75A.753.753,0,1,0,5.3,12.816L8.526,9.589l3.224,3.226a.753.753,0,1,0,1.065-1.065L9.591,8.524l3.228-3.229a.754.754,0,1,0-1.065-1.066L8.526,7.459,5.3,4.229A.753.753,0,0,0,4.758,4Z"
    //                                     transform="translate(-4 -4)"
    //                                     fill="#76ad94"
    //                                     stroke="#76ad94"
    //                                     strokeWidth="1"
    //                                     fillRule="evenodd"
    //                                   ></path>
    //                                 </g>
    //                               </g>
    //                             </svg>
    //                           </span>
    //                         )}
    //                         {item.message[0]}
    //                       </span>
    //                       {item.details.others.title && (
    //                         <h5>{item.details.others.title}</h5>
    //                       )}

    //                       <div class="cart-bulk-actions bulk-learner-list">
    //                         {item.learners && item.learners.length && _bfo ? (
    //                           item.learners.map((learner) => {
    //                             var learners = CartService.getLearner(
    //                               item.item
    //                             );
    //                             return (
    //                               <div class="learner_lists">
    //                                 <span class="name-letter">
    //                                   {learners[learner].name
    //                                     .charAt(0)
    //                                     .toUpperCase()}
    //                                 </span>
    //                                 <span
    //                                   class="learner-name"
    //                                   title={learners[learner].name}
    //                                 >
    //                                   {learners[learner].name}
    //                                 </span>
    //                                 <span
    //                                   class="mail-id"
    //                                   title={learners[learner].email}
    //                                 >
    //                                   {learners[learner].email}
    //                                 </span>
    //                               </div>
    //                             );
    //                           })
    //                         ) : (
    //                           <div></div>
    //                         )}
    //                       </div>
    //                     </div>
    //                   </div>
    //                 </div>
    //               </div>
    //             );
    //           })}
    //       </div>

    //       <div className="mt-25 skip-txt" onClick={this.props.closeCallBack}>
    //         Review Cart
    //       </div>
    //     </div>
    //   </div>
    // ) : (
    //   <div
    //     className="modal show fade in"
    //     id="courses"
    //     tabIndex={-1}
    //     role="dialog"
    //     aria-labelledby="exampleModalLabel"
    //     aria-hidden="true"
    //   >
    //     {/* sign in section start here */}
    //     <div className="course-wraper">
    //       {/* <button type="button" className="close cart-close" data-dismiss="modal">×</button> */}
    //       <div className="order-succes-icon">
    //         <svg
    //           xmlns="http://www.w3.org/2000/svg"
    //           width="82"
    //           height="82"
    //           viewBox="0 0 82 82"
    //         >
    //           <g
    //             id="Ellipse_107"
    //             data-name="Ellipse 107"
    //             transform="translate(10 10)"
    //             fill="#f58484"
    //             stroke="rgba(224,136,136,0.2)"
    //             strokeWidth="10"
    //           >
    //             <circle cx="31" cy="31" r="31" stroke="none" />
    //             <circle cx="31" cy="31" r="36" fill="none" />
    //           </g>
    //           <g
    //             id="Group_7"
    //             data-name="Group 7"
    //             transform="translate(2327.5 1155)"
    //           >
    //             <path
    //               id="Path_82"
    //               data-name="Path 82"
    //               d="M23071.385-21816.166l6.5-6.5,10.84-10.828"
    //               transform="translate(-25366.885 20710.992)"
    //               fill="none"
    //               stroke="#fff"
    //               strokeLinecap="round"
    //               strokeLinejoin="round"
    //               strokeWidth="5"
    //             />
    //             <path
    //               id="Path_82-2"
    //               data-name="Path 82"
    //               d="M23071.385-21816.166l6.5-6.5,10.84-10.828"
    //               transform="translate(-24111.666 -24193.885) rotate(90)"
    //               fill="none"
    //               stroke="#fff"
    //               strokeLinecap="round"
    //               strokeLinejoin="round"
    //               strokeWidth="5"
    //             />
    //           </g>
    //         </svg>
    //       </div>
    //       <h3 className="mt-1" id="subscription_succees_modal_type_text">
    //         {error[0].message[0]}
    //       </h3>
    //       {/* <p>{error[0].message[1]}</p> */}
    //       <button
    //         className="btn mt-2 mt-3 front_end_cart_btn theme-blue-btn1 orange-flat-btn"
    //         id="item_enroll_success_btn"
    //         data-dismiss="modal"
    //         onClick={this.closenandremove}
    //       // onClick={this.props.closeCallBack} removeCouponclosenandremove
    //       >
    //         Okay
    //       </button>
    //     </div>
    //   </div>
    // );
  }
}

function field_error(target, validation_params = null, force_error = null, item = null) {
  var errorExist = 0;
  var iserror = false;
  // e.target = document.getElementById('addLearnerForm');
  var message;
  if (validation_params) {
    message = validation_params.message
      ? validation_params.message
      : 'Please provide valid value';

    validation_params.regx = validation_params.regx
      ? validation_params.regx
      : /[\s\S]*/;
    if (validation_params.type == 'checkbox')
      target.value = target.checked ? 1 : '';
    if (!target.value && validation_params.required) {
      iserror = true;
    }
    if (target.value && !validation_params.regx.test(target.value)) {
      iserror = true;
    }
  }

  if (force_error) {
    message = force_error.message
      ? force_error.message
      : 'Please provide valid value';
    iserror = force_error.iserror;
  }

  if (iserror) {
    var s = `<span className="error-msg-icon">
		<svg xmlns="http://www.w3.org/2000/svg" width="16.4" height="16.4" viewBox="0 0 16.4 16.4">
            <circle id="Ellipse_63" data-name="Ellipse 63" cx="7.5" cy="7.5" r="7.5" transform="translate(0.7 0.7)" fill="#fff" stroke="#e30002" stroke-width="1.4"></circle>
            <path id="Path_59" data-name="Path 59" d="M822.5,583.685v4.54" transform="translate(-814.216 -579.681)" fill="none" stroke="#e30002" stroke-linecap="round" stroke-width="2"></path>
            <path id="Path_60" data-name="Path 60" d="M822.5,583.725v-.04" transform="translate(-814.216 -572.248)" fill="none" stroke="#e30002" stroke-linecap="round" stroke-width="2.4"></path>
        </svg>
	</span>
	${message}`;

    var htmlObject = document.createElement('span');
    htmlObject.className = 'error-msg';
    htmlObject.style.cssText = 'visibility:visible;';
    htmlObject.innerHTML = s;
    errorExist = 1;
    if (target.parentNode && !target.parentNode.querySelector('.error-msg')) {
      target.parentNode.append(htmlObject);
      target.className += ' error-border';
      document.getElementById('label_for_' + item) ? document.getElementById('label_for_' + item).style.display = 'none' : '';
    }
    if (message != '') {
      document.getElementById('label_for_' + item) ? document.getElementById('label_for_' + item).style.display = 'none' : '';
    }
  } else {
    errorExist = 0;
    if (target.parentNode && target.parentNode.querySelector('.error-msg')) {
     
      try {
        target.parentNode.removeChild(
          target.parentNode.querySelector('.error-msg')
        );
      } catch (error) {
        console.log("error occured",error)
      }
      target.className = target.className.replace('error-border', '');
      if (item == 'id') {
        item = 'name';
        document.getElementById('name').className = document.getElementById('name').className.replace('error-border', '');
      }
      document.getElementById('label_for_' + item) ? document.getElementById('label_for_' + item).style.display = '' : '';
    }
  }
  return errorExist;
}

function warning(target, validation_params = null, force_error = null) {
  var errorExist = 0;
  var iserror = false;
  var message;
  if (validation_params) {
    message = validation_params.message
      ? validation_params.message
      : 'Please provide valid value';

    validation_params.regx = validation_params.regx
      ? validation_params.regx
      : /[\s\S]*/;
    if (validation_params.type == 'checkbox')
      target.value = target.checked ? 1 : '';
    if (!target.value && validation_params.required) iserror = true;
    if (target.value && !validation_params.regx.test(target.value))
      iserror = true;
  }

  if (force_error) {
    message = force_error.message
      ? force_error.message
      : 'Please provide valid value';
    iserror = force_error.iserror;
  }

  if (iserror) {
    var s = `<span className="warning-msg-icon">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16.4"
			height="16.4"
			viewBox="0 0 16.4 16.4"
		>
			<circle
				id="Ellipse_63"
				data-name="Ellipse 63"
				cx="7.5"
				cy="7.5"
				r="7.5"
				transform="translate(0.7 0.7)"
				fill="#fff"
				stroke="#d7a30e"
				strokeWidth="1.4"
			/>
			<path
				id="Path_59"
				data-name="Path 59"
				d="M822.5,583.685v4.54"
				transform="translate(-814.216 -579.681)"
				fill="none"
				stroke="#d7a30e"
				strokeLinecap="round"
				strokeWidth={2}
			/>
			<path
				id="Path_60"
				data-name="Path 60"
				d="M822.5,583.725v-.04"
				transform="translate(-814.216 -572.248)"
				fill="none"
				stroke="#d7a30e"
				strokeLinecap="round"
				strokeWidth="2.4"
			/>
		</svg>
	</span>
	${message}`;

    var htmlObject = document.createElement('span');
    htmlObject.className = 'warning-msg';
    htmlObject.style.cssText = 'visibility:visible;';
    htmlObject.innerHTML = s;
    errorExist = 1;
    if (target.parentNode && !target.parentNode.querySelector('.warning-msg')) {
      target.parentNode.append(htmlObject);
      target.className += ' warning-border';
    }
  } else {
    errorExist = 0;
    if (target.parentNode && target.parentNode.querySelector('.warning-msg')) {
      try {
        target.parentNode.removeChild(
          target.parentNode.querySelector('.warning-msg')
        );
      } catch (error) {
        console.log("error occured",error)
      }
    
      target.className = target.className.replace('warning-border', '');
    }
  }
  return;
}

export class AddAddress extends React.Component {
  constructor(props) {
    document.body.className += ' disable_background_scroll';
    super(props);
    this.state = {
      address: null,
      countries: [],
    };

    this.state.address = CartService.getAddress();
    this.dissmissmodal = this.dissmissmodal.bind(this);
  }

  componentDidMount() {
    this.setState({
      countries: JSON.parse(
        localStorage.getItem('countries')
          ? localStorage.getItem('countries')
          : '[]'
      ),
    });

    // document.querySelector('input').addEventListener('blur', function(){
    // 	//console.log('blurreddd');
    // 			document.querySelector(this).parent().querySelector('label').removeClass("focus");
    // 			});
    // 			document.querySelector('input').addEventListener('focus', function(){
    // 			document.querySelector(this).parent().querySelector('label').classList.add("focus");
    // 	});
    // 	 document.querySelector('input').keyup(function(){
    // 			if(document.querySelector(this).value){
    // 					document.querySelector(this).parent().querySelector('label').classList.add("active");
    // 			}else{
    // 					document.querySelector(this).parent().querySelector('label').removeClass("active");
    // 			}
    // 	});
    // fetch(__siteUrl + "/mykademy/api/v1/countries", {
    // 	method: "GET",
    // 	headers: {
    // 		Accept: "application/json",
    // 		"Content-Type": "application/json",
    // 	},
    // })
    // 	.then((res) => res.json())
    // 	.then((result) => {
    // 		this.setState({ countries: result.data });
    // 	});
  }

  dissmissmodal() {
    document.body.className = document.body.className.replace(
      'disable_background_scroll',
      ''
    );
    this.props.dissmissmodal();
  }

  saveaddress = (e) => {
    e.preventDefault();
    var errorExist = 0;
    var data = {};
    var noskip;
    //learner info
    var inputs = {
      full_name: {
        required: true,
        regx: '',
        message: 'Please enter your First and Last Name.',
      },
      email: {
        required: true,
        regx: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        message: 'You have entered an incorrect email.',
      },
      country_code: {
        required: true,
        regx: '',
        message: 'Enter the country code in the correct format.',
      },
      phone: {
        required: true,
        regx: /^\d{10}$/,
        message: 'Enter the phone number in the correct format.',
      },
      street_po: {
        required: true,
        regx: '',
        message: 'Oops! It seems like you have not filled in steet/po',
      },
      subrub: {
        required: true,
        regx: '',
        message: 'Oops! It seems like you have not filled in subrub',
      },
      city: {
        required: true,
        regx: '',
        message: 'Oops! It seems like you have not filled in city',
      },
      country: {
        required: true,
        regx: '',
        message: 'Oops! It seems like you have not filled in country',
      },
      county: {
        required: true,
        regx: '',
        message: 'Oops! It seems like you have not filled in county',
      },
      postcode: {
        required: true,
        regx: /^[a-zA-Z0-9\s]{5,10}$/,
        // 'regx': /^[0-9]{5,10}$/,
        message: 'Oops! It seems like you have not filled in postcode',
      },
    };
    
    Object.keys(inputs).every(function (item, index) {
      // if (index > 4 && e.target.has_pps.value == 1) {
      // 	return false;
      // }
      // noskip = 1;
      // if (e.target.has_pps.value == 0 && item =='pps_number') {
      // 	noskip = 0;
      // }

      data[item] = e.target[item].value;
      errorExist += field_error(e.target[item], inputs[item], null, item);
      return true;
    });
    if (errorExist == 0) {
      data['id'] = '';
      CartService.saveAddress(data);
      this.dissmissmodal();
      this.props.refresh();
    }
  };


  changefn = (e) => {
    // parent class change handler is always called with field name and value
    this.setState({[e.target.name]: e.target.value});
  }

  render() {
    var _ccode = '';
    const address = this.state.address;
    return (
      <div
        className="modal add_address_form show fade in"
        id="bill_address"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <form
          action="#"
          method="post"
          id="addLearnerForm"
          onSubmit={this.saveaddress}
        >
          <div className="pps-details-sec">
            <div className="pps-form-header">
              <button
                type="button"
                className="close cart-close"
                onClick={this.dissmissmodal}
              >
                ×
              </button>
              <h5>Details</h5>
              <p className="pr-4">
                Submit the details of the person who ordered the course, to
                proceed.
              </p>
            </div>

            <div className="col-md-6 pl-0 pr-1">
              <div className="form-group form-group-alter ">
                {' '}
                <span>
                  <label
                    className={address && address.full_name || this.state.full_name ? 'active focus' : ''}
                  >
                    Full Name
                  </label>
                  <input
                    type="text"
                    name="full_name"
                    defaultValue={
                      address && address.full_name ? address.full_name : ''
                    }
                    className="form-control form-alter"
                    onChange={this.changefn}
                  />
                </span>
              </div>
            </div>
            <div className="col-md-6 pr-0 pl-1">
              <div className="form-group form-group-alter ">
                {' '}
                <span>
                  <label className={address && address.email || this.state.email ? 'active' : ''}>
                    Email Address
                  </label>
                  <input
                    type="text"
                    name="email"
                    defaultValue={address && address.email ? address.email : ''}
                    className="form-control form-alter"
                    onChange={this.changefn}
                  />
                </span>
              </div>
            </div>
            <div className="col-md-6 pl-0 pr-1">
              <div className="form-group form-group-alter">
                <span className="select-item">
                  <label
                    className={address && address.country_code || this.state.country_code  ? 'active' : ''}
                  >
                    Code
                  </label>

                  {this.state.countries.map((item, i) => {
                    if (
                      !address.country_code &&
                      _userCountryCode &&
                      item.country_code == _userCountryCode
                    ) {
                      _ccode = item.id;
                    }
                  })}
                  <select
                    name="country_code"
                    defaultValue={{ label: 'Select Code', value: _ccode }}
                  >
                    {this.state.countries.map((item, i) => {
                      var _selected =
                        address && item.id == address.country_code
                          ? true
                          : false;
                      if (
                        !address.country_code &&
                        _userCountryCode &&
                        item.country_code == _userCountryCode
                      ) {
                        _selected = true;
                      }
                      return (
                        <option value={item.id} selected={_selected}>
                          +{item.calling_code}
                        </option>
                      );
                    })}
                  </select>
                </span>
                <span className="number">
                  <label className={address && address.phone || this.state.phone ? 'active' : ''}>
                    Phone Number
                  </label>
                  <input
                    type="number"
                    maxLength={10}
                    name="phone"
                    defaultValue={address && address.phone ? address.phone : ''}
                    className="form-control form-alter"
                    onChange={this.changefn}
                  />
                </span>
              </div>
            </div>
            <div className="col-md-12 p-0 cart-sub-text">Billing Address</div>
            <div className="col-md-6 pl-0 pr-1">
              <div className="form-group form-group-alter ">
                <span>
                  <label
                    className={address && address.street_po  || this.state.street_po ? 'active' : ''}
                  >
                    Street/PO
                  </label>
                  <input
                    type="text"
                    name="street_po"
                    defaultValue={
                      address && address.street_po ? address.street_po : ''
                    }
                    className="form-control form-alter"
                    onChange={this.changefn}
                  />
                </span>
              </div>
            </div>
            <div className="col-md-6 pr-0 pl-1">
              <div className="form-group form-group-alter ">
                <span>
                  <label className={address && address.subrub || this.state.subrub ? 'active' : ''}>
                    Suburb 
                  </label>
                  <input
                    type="text"
                    name="subrub"
                    defaultValue={
                      address && address.subrub ? address.subrub : ''
                    }
                    className="form-control form-alter"
                    onChange={this.changefn}
                  />
                </span>
              </div>
            </div>
            <div className="col-md-6 pl-0 pr-1">
              <div className="form-group form-group-alter ">
                <span>
                  <label className={address && address.city  || this.state.city ? 'active' : ''}>
                    City
                  </label>
                  <input
                    type="text"
                    name="city"
                    defaultValue={address && address.city ? address.city : ''}
                    className="form-control form-alter"
                    onChange={this.changefn}
                  />
                </span>
              </div>
            </div>
            <div className="col-md-6 pr-0 pl-1">
              <div className="form-group form-group-alter ">
                <span>
                  <label className={address && address.county || this.state.county  ? 'active' : ''}>
                    County
                  </label>
                  <input
                    type="text"
                    name="county"
                    defaultValue={
                      address && address.county ? address.county : ''
                    }
                    className="form-control form-alter"
                    onChange={this.changefn}
                  />
                </span>
              </div>
            </div>
            <div className="col-md-6 pl-0 pr-1">
              <div className="form-group form-group-alter ">
                <span>
                  <label
                    className={address && address.postcode || this.state.postcode ? 'active' : ''}
                  >
                    PostCode
                  </label>
                  <input
                    type="text"
                    name="postcode"
                    defaultValue={
                      address && address.postcode ? address.postcode : ''
                    }
                    className="form-control form-alter"
                    onChange={this.changefn}
                  />
                </span>
              </div>
            </div>

            <div className="col-md-6 pr-0 pl-1">
              <div className="form-group form-group-alter ">
                <span className="select-item" style={{ width: '100%' }}>
                  <label className={address && address.country ? 'active' : ''}>
                    Country
                  </label>

                  <select
                    name="country"
                    defaultValue={{
                      label: 'Select Country',
                      value: address && address.country ? address.country : '',
                    }}
                  >
                    {/* <option value=""></option> */}
                    {this.state.countries.map((item, i) => {
                      var _selected =
                        address && item.id == address.country_code
                          ? true
                          : false;
                      if (
                        !address.country_code &&
                        _userCountryCode &&
                        item.country_code == _userCountryCode
                      ) {
                        _selected = true;
                      }
                      return (
                        <option value={item.id} selected={_selected}>
                          {item.country_name}
                        </option>
                      );
                    })}
                  </select>
                  {/* <input
										type="text"
										
										name="country"
										defaultValue={address && address.country ? address.country : ''}
										className="form-control form-alter"
									/> */}
                </span>
              </div>
            </div>
            <div className="bulk-cart-btn">
              <div className="btn cart-btn h-45 mt-2 theme-blue-btn1 w-75 mr-center-align">
                {/* <a id="pps_form_btn">
								Add Address
							</a> */}

                <button id="pps_form_btn" type="submit">
                  Add Address
                  {/* Save Address */}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export class LearnerListing extends React.Component {
  constructor(props) {
    document.body.className += ' disable_background_scroll';
    super(props);
    this.state = {
      id: this.props.data.id,
      name: this.props.title,
      type: this.props.data.type,
      key: this.props.data.type + '_' + this.props.data.id,
      learners: [],
      applied_coupon_detail: _couponApplied.data,
    };
    this.dissmissmodal = this.dissmissmodal.bind(this);
  }

  removelearner = (param) => {
    CartService.removeLearner(this.state.key, param);
    this.setState({
      learners: [],
    });
  };

  dissmissmodal() {
    document.body.className = document.body.className.replace(
      'disable_background_scroll',
      ''
    );
    this.props.dissmissmodal();
    this.props.refresh();
  }
  editlearner = (param, index) => {
    this.props.editlearner(param, index, this.state.key);
    // this.setState({
    // 	setdata:param,
    // 	learnerindex:index,
    // 	key:this.state.key,
    // 	addlearner:true,
    // });
  };

  render() {
    this.state.learners  = CartService.getLearner(this.state.key);
    this.state.itemPrice = CartService.getitemprice(this.state.key);

    // IF LIMIT SUBSCRIBER ENABLE
    if (this.state.applied_coupon_detail && Number(this.state.applied_coupon_detail.pc_subscriber_coupons_remaining) > 0)
    {
      var coupon_limit_learner_usage_found  = 1;
      var coupon_limit_learner_usage_count  = this.state.applied_coupon_detail.pc_subscriber_coupons_remaining;
      var coupon_limit_learner_localstorage = localStorage.getItem('coupon_limit_learner_usage');


      if (!coupon_limit_learner_localstorage)
      {
        localStorage.setItem('coupon_limit_learner_usage', coupon_limit_learner_usage_count);
        coupon_limit_learner_localstorage = localStorage.getItem('coupon_limit_learner_usage');
      }
    }


    var learners = Object.keys(this.state.learners)
      // .reverse()
      .reduce((obj, key) => {
        obj[key] = this.state.learners[key];
        return obj;
      }, {});
      
      const key = this.state.key;
      const cart = JSON.parse(localStorage.getItem('mycart'));

      let cartData = CartService.getCart();
     
    return (
      <div
        className="modal add_address_form show fade in"
        id="learners-list"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="pps-details-sec">
          <button
            type="button"
            className="close cart-close"
            onClick={this.dissmissmodal}
          >
            ×
          </button>
          <div className="cart-box bulk-box waiting-list-box">
            <div className="d-flex">
              <div className="cart-img">
                <img
                  src={this.props.data.img}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = default_img;
                  }}
                />
              </div>
              <div className="cart-txtbar  justify-content-between">
                <div className="cart-text">
                  <h5>{this.props.data.name}</h5>
                </div>
              </div>
            </div>
            <div className="cart-bulk-actions bulk-learner-list">
              <h5>{Object.keys(learners).length} Learners</h5>
              <div className="add-learner-details-block-wrap item-learner-wrapper">
              {Object.keys(learners).length != 0 &&
                Object.keys(learners).map((index, item) => {
                  return (
                    /*
                    <div key={learners[index].email} className="learner_lists">
                      <span className="name-letter">
                        {learners[index].name.charAt(0).toUpperCase()}
                      </span>
                      <span className="learner-name">
                        {learners[index].name}
                      </span>
                      <span className="mail-id">{learners[index].email}</span>
                      <span className="learner-list-action">
                        <span
                          className="edit-svg"
                          onClick={() =>
                            this.editlearner(learners[index], index)
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            // xmlns:svgjs="http://svgjs.com/svgjs"
                            width={20}
                            height={20}
                            x={0}
                            y={0}
                            viewBox="0 0 492.49284 492"
                            style={{ enableBackground: 'new 0 0 512 512' }}
                            xmlSpace="preserve"
                          >
                            <g>
                              <path
                                xmlns="http://www.w3.org/2000/svg"
                                d="m304.140625 82.472656-270.976563 270.996094c-1.363281 1.367188-2.347656 3.09375-2.816406 4.949219l-30.035156 120.554687c-.898438 3.628906.167969 7.488282 2.816406 10.136719 2.003906 2.003906 4.734375 3.113281 7.527344 3.113281.855469 0 1.730469-.105468 2.582031-.320312l120.554688-30.039063c1.878906-.46875 3.585937-1.449219 4.949219-2.8125l271-270.976562zm0 0"
                                fill="#2d71fd"
                                data-original="#000000"
                              />
                              <path
                                xmlns="http://www.w3.org/2000/svg"
                                d="m476.875 45.523438-30.164062-30.164063c-20.160157-20.160156-55.296876-20.140625-75.433594 0l-36.949219 36.949219 105.597656 105.597656 36.949219-36.949219c10.070312-10.066406 15.617188-23.464843 15.617188-37.714843s-5.546876-27.648438-15.617188-37.71875zm0 0"
                                fill="#2d71fd"
                                data-original="#000000"
                              />
                            </g>
                          </svg>
                        </span>
                        <i
                          className="icon icon-trash-empty m-0"
                          onClick={() => this.removelearner(learners[index])}
                        />
                      </span>
                    </div>
                    */

                    <div className="add-leaner-details-block ">
                  <div className="add-leaner-details">
                    <div className="addlearner-info">
                      <div className="addleaner-name">
                        <span
                          className={
                            this.state.itemPrice.member_status == 1 &&
                            _showMember == '1' &&
                            learners[index].is_member == '1'
                              ? 'addleaner-name-icon green-icon'
                              : 'addleaner-name-icon blue-icon'
                          }
                        >{learners[index].name.charAt(0).toUpperCase()}</span>
                        
                        <div className="addlearner-name_email">
                          <p>{learners[index].name}</p>
                          <p class="addleaner-email"><a href="#">{learners[index].email}</a></p>
                          <div>
                          {this.state.itemPrice.isfree != 1 ? (
                        <div
                          className={
                            this.state.itemPrice.member_status == 1 &&
                            _showMember == '1' &&
                            learners[index].is_member == '1'
                              ? 'addleaner-cp green-color-cp'
                              : 'addleaner-cp'
                          }
                        >
                          {this.state.itemPrice.member_status == 1 &&
                          _showMember == '1' &&
                          learners[index].is_member == '1'
                            ? _memberLabel
                            :_currentLabel}
                        </div>
                      ) : (
                        _free_course_label
                      )}
                          </div>
                        </div>
                      </div>
                    </div>
                  <div className="price-actions-wrapper">
                    <div className="addlearner-price-info">
                      <div className="addleaner-price">
                        {/*<span className="addleaner-clse">×</span>*/}
                        {this.state.itemPrice.isfree != 1 ? (
                          <>
                            {
                              (<p>Price :
                                <span className="rupee-unicode">
                                  {current_currency}
                                </span>
                                {this.state.itemPrice.member_status == 1 &&
                                _showMember == '1' &&
                                learners[index].is_member == '1'
                                  ? this.state.itemPrice.member_price
                                  : this.state.itemPrice.discount_price > 0
                                  ? this.state.itemPrice.discount_price
                                  : this.state.itemPrice.price
                                }
                              </p>)
                            }
                            
                            {learners[index].is_bulk_learner_discount && learners[index].is_bulk_learner_discount  == 1 ?
                              (<p>
                                <span className="rupee-unicode">
                                  {learners[index].discount_price > 0 ? 'Coupon Discount: ' + current_currency + learners[index].discount_price : ('')}
                                </span>
                              </p>)
                              : ('')
                            }
                            
                            {learners[index].is_bulk_learner_discount && learners[index].is_bulk_learner_discount  == 1 ?
                              (<p>
                                <span className="rupee-unicode">
                                  {learners[index].total_after_discount > 0 ? 'Total:' + current_currency + learners[index].total_after_discount : ('')}
                                </span>
                              </p>)
                              : ('')
                            }
                           
                          </>

                        ) : (
                          ''
                        )}

                        {/* {this.state.itemPrice.isfree != 1 ? (
                          <>
                            <s>
                              <span className="rupee-unicode">
                                {current_currency}
                              </span>
                              {this.state.itemPrice.member_status == 1 &&
                              _showMember == '1' &&
                              learners[index].is_member == '1'
                                ? this.state.itemPrice.member_price
                                : this.state.itemPrice.discount_price > 0
                                ? this.state.itemPrice.discount_price
                                : this.state.itemPrice.price}
                            </s>
                              {' '}<span className="rupee-unicode">
                              {current_currency}
                            </span>{'25'}
                          </>
                        ) : (
                          ''
                        )} */}
                      </div>

                      
                    </div>
                    <div className="addleaner-edit-info item-learner-actions-wrapper">
                      <div className="item-learner_action-inner-wrapper">
                        <span
                          className="addleaner-edit item-learner-action"
                          onClick={() =>
                            this.editlearner(learners[index], index)
                          }
                        >
                          <svg
                            version="1.1"
                            id="Capa_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="528.899px"
                            height="528.899px"
                            viewBox="0 0 528.899 528.899"
                            xmlSpace="preserve"
                          >
                            <g>
                              <path
                                d="M328.883,89.125l107.59,107.589l-272.34,272.34L56.604,361.465L328.883,89.125z M518.113,63.177l-47.981-47.981
               c-18.543-18.543-48.653-18.543-67.259,0l-45.961,45.961l107.59,107.59l53.611-53.611
               C532.495,100.753,532.495,77.559,518.113,63.177z M0.3,512.69c-1.958,8.812,5.998,16.708,14.811,14.565l119.891-29.069
               L27.473,390.597L0.3,512.69z"
                              />
                            </g>
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                          </svg>Edit
                        </span>
                        <span class="separator-line"></span>
                        <span
                          className="addleaner-delete item-learner-action"
                          onClick={() => this.removelearner(learners[index])}
                        >
                          <svg
                            version="1.1"
                            id="Capa_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            viewBox="0 0 612 612"
                            style={{ enableBackground: 'new 0 0 612 612' }}
                            width="12px"
                            height="12px"
                            xmlSpace="preserve"
                          >
                            <g>
                              <g>
                                <path
                                  d="M493.8,170.8H118.2c-11.4,0-20.6,9.2-20.6,20.6v321.5c0,54.6,44.5,99.1,99.1,99.1h218.6c54.6,0,99.1-44.5,99.1-99.1V191.4
                       C514.4,180,505.2,170.8,493.8,170.8z M256.5,488c0,14-11.3,25.3-25.3,25.3c-14,0-25.3-11.3-25.3-25.3V294.8
                       c0-14,11.3-25.3,25.3-25.3c14,0,25.3,11.3,25.3,25.3V488z M406,488c0,14-11.3,25.3-25.3,25.3c-14,0-25.3-11.3-25.3-25.3V294.8
                       c0-14,11.3-25.3,25.3-25.3c14,0,25.3,11.3,25.3,25.3V488z"
                                />
                                <path
                                  d="M473.2,32h-89.7v-7.8c0-13.4-10.9-24.2-24.2-24.2H252.7c-13.4,0-24.2,10.9-24.2,24.2V32h-89.7C104.5,32,76.5,60,76.5,94.3
                       v39.9c0,7.1,5.8,12.9,12.9,12.9h433.1c7.1,0,12.9-5.8,12.9-12.9V94.3C535.5,60,507.5,32,473.2,32z"
                                />
                              </g>
                            </g>
                          </svg>Delete
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                  );
                })}
              </div>
              {Object.keys(learners).length == 0 && 'No learners'}
              <div
                className="btn done-btn theme-blue-btn1"
                onClick={this.dissmissmodal}
              >
                Done
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export class WaitingListListing extends React.Component {
  constructor(props) {
    document.body.className += ' disable_background_scroll';
    super(props);
    this.state = {
      id: this.props.data.id,
      name: this.props.title,
      type: this.props.data.type,
      key: this.props.data.type + '_' + this.props.data.id,
      waitingList: [],
      applied_coupon_detail: _couponApplied.data,
    };
    this.dissmisswaitmodal = this.dissmisswaitmodal.bind(this);
  }

  removelearner = (param) => {
    CartService.removeLearner(this.state.key, param);
    this.setState({
      waitingList: [],
    });
  };

  dissmisswaitmodal() {
    document.body.className = document.body.className.replace(
      'disable_background_scroll',
      ''
    );
    this.props.dissmisswaitmodal();
    this.props.refresh();
  }
  editlearner = (param, index) => {
    this.props.editlearner(param, index, this.state.key);
    // this.setState({
    // 	setdata:param,
    // 	learnerindex:index,
    // 	key:this.state.key,
    // 	addlearner:true,
    // });
  };

  render() {
    this.state.waitingList  = CartService.getWaitingList(this.state.key);
    this.state.itemPrice = CartService.getitemprice(this.state.key);

    // IF LIMIT SUBSCRIBER ENABLE
    if (this.state.applied_coupon_detail && Number(this.state.applied_coupon_detail.pc_subscriber_coupons_remaining) > 0)
    {
      var coupon_limit_learner_usage_found  = 1;
      var coupon_limit_learner_usage_count  = this.state.applied_coupon_detail.pc_subscriber_coupons_remaining;
      var coupon_limit_learner_localstorage = localStorage.getItem('coupon_limit_learner_usage');


      if (!coupon_limit_learner_localstorage)
      {
        localStorage.setItem('coupon_limit_learner_usage', coupon_limit_learner_usage_count);
        coupon_limit_learner_localstorage = localStorage.getItem('coupon_limit_learner_usage');
      }
    }


    var waitingList = Object.keys(this.state.waitingList)
      // .reverse()
      .reduce((obj, key) => {
        obj[key] = this.state.waitingList[key];
        return obj;
      }, {});
      
      const key = this.state.key;
      const cart = JSON.parse(localStorage.getItem('mycart'));

      let cartData = CartService.getCart();
     
    return (
      <div
        className="modal add_address_form show fade in"
        id="learners-list"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="pps-details-sec">
          <button
            type="button"
            className="close cart-close"
            onClick={this.dissmisswaitmodal}
          >
            ×
          </button>
          <div className="cart-box bulk-box waiting-list-box">
            <div className="d-flex">
              <div className="cart-img">
                <img
                  src={this.props.data.img}
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = default_img;
                  }}
                />
              </div>
              <div className="cart-txtbar  justify-content-between">
                <div className="cart-text">
                  <h5>{this.props.data.name}</h5>
                </div>
              </div>
            </div>
            <div className="cart-bulk-actions bulk-learner-list">
              <h5>{Object.keys(waitingList).length} waiting List</h5>
              <div className="add-learner-details-block-wrap item-learner-wrapper b">
              {Object.keys(waitingList).length != 0 &&
                Object.keys(waitingList).map((index, item) => {
                  return (
                    /*
                    <div key={learners[index].email} className="learner_lists">
                      <span className="name-letter">
                        {learners[index].name.charAt(0).toUpperCase()}
                      </span>
                      <span className="learner-name">
                        {learners[index].name}
                      </span>
                      <span className="mail-id">{learners[index].email}</span>
                      <span className="learner-list-action">
                        <span
                          className="edit-svg"
                          onClick={() =>
                            this.editlearner(learners[index], index)
                          }
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            version="1.1"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            // xmlns:svgjs="http://svgjs.com/svgjs"
                            width={20}
                            height={20}
                            x={0}
                            y={0}
                            viewBox="0 0 492.49284 492"
                            style={{ enableBackground: 'new 0 0 512 512' }}
                            xmlSpace="preserve"
                          >
                            <g>
                              <path
                                xmlns="http://www.w3.org/2000/svg"
                                d="m304.140625 82.472656-270.976563 270.996094c-1.363281 1.367188-2.347656 3.09375-2.816406 4.949219l-30.035156 120.554687c-.898438 3.628906.167969 7.488282 2.816406 10.136719 2.003906 2.003906 4.734375 3.113281 7.527344 3.113281.855469 0 1.730469-.105468 2.582031-.320312l120.554688-30.039063c1.878906-.46875 3.585937-1.449219 4.949219-2.8125l271-270.976562zm0 0"
                                fill="#2d71fd"
                                data-original="#000000"
                              />
                              <path
                                xmlns="http://www.w3.org/2000/svg"
                                d="m476.875 45.523438-30.164062-30.164063c-20.160157-20.160156-55.296876-20.140625-75.433594 0l-36.949219 36.949219 105.597656 105.597656 36.949219-36.949219c10.070312-10.066406 15.617188-23.464843 15.617188-37.714843s-5.546876-27.648438-15.617188-37.71875zm0 0"
                                fill="#2d71fd"
                                data-original="#000000"
                              />
                            </g>
                          </svg>
                        </span>
                        <i
                          className="icon icon-trash-empty m-0"
                          onClick={() => this.removelearner(learners[index])}
                        />
                      </span>
                    </div>
                    */

                    <div className="add-leaner-details-block ">
                  <div className="add-leaner-details">
                    <div className="addlearner-info">
                      <div className="addleaner-name">
                        <span
                          className={
                            this.state.itemPrice.member_status == 1 &&
                            _showMember == '1' &&
                            waitingList[index].is_member == '1'
                              ? 'addleaner-name-icon green-icon'
                              : 'addleaner-name-icon blue-icon'
                          }
                        >{waitingList[index].name.charAt(0).toUpperCase()}</span>
                        
                        <div className="addlearner-name_email">
                          <p>{waitingList[index].name}</p>
                          <p class="addleaner-email"><a href="#">{waitingList[index].email}</a></p>
                        </div>
                      </div>
                    </div>
                  <div className="price-actions-wrapper">
                    <div className="addleaner-edit-info item-learner-actions-wrapper">
                      <div className="item-learner_action-inner-wrapper">
                        <span
                          className="addleaner-edit item-learner-action"
                          onClick={() =>
                            this.editlearner(waitingList[index], index)
                          }
                        >
                          <svg
                            version="1.1"
                            id="Capa_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            width="528.899px"
                            height="528.899px"
                            viewBox="0 0 528.899 528.899"
                            xmlSpace="preserve"
                          >
                            <g>
                              <path
                                d="M328.883,89.125l107.59,107.589l-272.34,272.34L56.604,361.465L328.883,89.125z M518.113,63.177l-47.981-47.981
               c-18.543-18.543-48.653-18.543-67.259,0l-45.961,45.961l107.59,107.59l53.611-53.611
               C532.495,100.753,532.495,77.559,518.113,63.177z M0.3,512.69c-1.958,8.812,5.998,16.708,14.811,14.565l119.891-29.069
               L27.473,390.597L0.3,512.69z"
                              />
                            </g>
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                            <g />
                          </svg>Edit
                        </span>
                        <span class="separator-line"></span>
                        <span
                          className="addleaner-delete item-learner-action"
                          onClick={() => this.removelearner(waitingList[index])}
                        >
                          <svg
                            version="1.1"
                            id="Capa_1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            x="0px"
                            y="0px"
                            viewBox="0 0 612 612"
                            style={{ enableBackground: 'new 0 0 612 612' }}
                            width="12px"
                            height="12px"
                            xmlSpace="preserve"
                          >
                            <g>
                              <g>
                                <path
                                  d="M493.8,170.8H118.2c-11.4,0-20.6,9.2-20.6,20.6v321.5c0,54.6,44.5,99.1,99.1,99.1h218.6c54.6,0,99.1-44.5,99.1-99.1V191.4
                       C514.4,180,505.2,170.8,493.8,170.8z M256.5,488c0,14-11.3,25.3-25.3,25.3c-14,0-25.3-11.3-25.3-25.3V294.8
                       c0-14,11.3-25.3,25.3-25.3c14,0,25.3,11.3,25.3,25.3V488z M406,488c0,14-11.3,25.3-25.3,25.3c-14,0-25.3-11.3-25.3-25.3V294.8
                       c0-14,11.3-25.3,25.3-25.3c14,0,25.3,11.3,25.3,25.3V488z"
                                />
                                <path
                                  d="M473.2,32h-89.7v-7.8c0-13.4-10.9-24.2-24.2-24.2H252.7c-13.4,0-24.2,10.9-24.2,24.2V32h-89.7C104.5,32,76.5,60,76.5,94.3
                       v39.9c0,7.1,5.8,12.9,12.9,12.9h433.1c7.1,0,12.9-5.8,12.9-12.9V94.3C535.5,60,507.5,32,473.2,32z"
                                />
                              </g>
                            </g>
                          </svg>Delete
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
                  );
                })}
              </div>
              {Object.keys(waitingList).length == 0 && 'No learners in waiting list'}
              <div
                className="btn done-btn theme-blue-btn1"
                onClick={this.dissmisswaitmodal}
              >
                Done
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


class Dynamic_field extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      organistaion_id: '',
    };
  }

  handledatalist = (e) => {
    Object.keys(_dynamic_fields['organisation']['range']).find((org) => {
      var range = _dynamic_fields['organisation']['range'];
      if (range[org] === e.target.value) {
        this.setState({ organistaion_id: org });
      }
    });
  };

  changefn = (e) => {
    // parent class change handler is always called with field name and value
    this.setState({[e.target.name]: e.target.value});
  }

  componentDidMount() {
    document.addEventListener('focus', this.handleFocus, true);
    document.addEventListener('blur', this.handleBlur, true);
    document.addEventListener('input', this.handleInput, true);
  }

  componentWillUnmount() {
    document.removeEventListener('focus', this.handleFocus, true);
    document.removeEventListener('blur', this.handleBlur, true);
    document.removeEventListener('input', this.handleInput, true);
  }

  handleFocus = (event) => {
    let target = event.target;
    while (target && target !== document) {
      if (target.matches('#cartBlock input')) {
        target.parentNode.querySelector('label').classList.add("focus");
        return;
      }
      target = target.parentNode;
    }
  };

  handleBlur = (event) => {
    let target = event.target;
    while (target && target !== document) {
      if (target.matches('#cartBlock input')) {
        const input = target;
        const label = input.parentNode.querySelector('label');
        if (input.value) {
          label.classList.remove("focus");
          label.classList.add("active");
        } else {
          label.classList.remove("focus", "active");
        }
        return;
      }
      target = target.parentNode;
    }
  };

  handleInput = (event) => {
    let target = event.target;
    while (target && target !== document) {
      if (target.matches('#cartBlock input')) {
        const input = target;
        const label = input.parentNode.querySelector('label');
        if (input.value) {
          label.classList.add("active");
        } else {
          label.classList.remove("active");
        }
        return;
      }
      target = target.parentNode;
    }
  };

  render() {
    var data = this.props.data ? this.props.data : null;
    var metadata = this.props.metadata ? this.props.metadata : null;
    var isedit   = this.props.isEdit ? this.props.isEdit : false;
    var readonly = this.props.readonly ? this.props.readonly : false;
    var organistaion_id = this.state.organistaion_id
      ? this.state.organistaion_id
      : '';
    return (
      <>
        {Object.keys(_dynamic_fields).map((item) => {
          if (item == 'organisation') { 
            {
              /* console.log((data && data[item]) ? data[item] : '',data,item); */
            }
            return (
              <div className="col-md-6">
                <div className="form-group form-group-alter ">
                  <span>
                    <label className={data && data[item] || this.state.organistaion_id ? 'active' : ''}>
                      {_dynamic_fields[item]['label']}
                    </label>
                    <input
                      type="text"
                      list={item}
                      name={item}
                      onChange={this.handledatalist}
                      onClick={this.changefn}
                      readOnly={!isedit && metadata && metadata[item]}
                      defaultValue={data && data[item] ? data[item] : ''}
                      className="form-control form-alter"
                    />
                    <input
                      type="hidden"
                      name={item + '_id'}
                      defaultValue={
                        data && data['organisation_id']
                          ? data['organisation_id']
                          : ''
                      }
                      className="form-control form-alter"
                    />
                    {/* <input
											type="hidden"
											name={item+'_value'}
											// placeholder={_dynamic_fields[item]['placeholder']}
											maxLength={10}
											defaultValue={(data && data[item]) ? data[item] : ''}
											className="form-control form-alter"
										/> */}
                    <datalist id={item}>
                      {Object.keys(_dynamic_fields[item]['range']).map(
                        (option, i) => {
                          var range = _dynamic_fields[item]['range'];
                          return (
                            <option
                              key-value={option}
                              value={range[option]}
                            ></option>
                          );
                        }
                      )}
                      {/* <option value="Edge"></option>
											<option value="Firefox"></option>
											<option value="Chrome"></option>
											<option value="Opera"></option>
											<option value="Safari"></option> */}
                    </datalist>


                    <div id={"label_for_" + item} class="field-info">
                      {
                        typeof _dynamic_fields[item]['purpose_field'] != 'undefined' &&
                        _dynamic_fields[item]['purpose_field']
                      }
                      
                    </div>

                  </span>

                </div>
              </div>
            );
          } else if (
            _dynamic_fields[item]['type'] == 'text' &&
            item != 'phone'
          )
          {
            return (
              <div className="col-md-6">
                <div className="form-group form-group-alter ">
                  <span>
                    <label className={data && data[item] || this.state[item] ? 'active' : ''}>
                      {_dynamic_fields[item]['label']}
                    </label>
                    <input
                      type="text"
                      name={item}
                      // placeholder={_dynamic_fields[item]['placeholder']}
                      maxLength={10}
                      readOnly={!isedit && metadata && metadata[item]}
                      defaultValue={data && data[item] ? data[item] : ''}
                      className="form-control form-alter"
                      onChange={this.changefn}
                    />
                    <div id={"label_for_" + item} class="field-info">
                      {
                        typeof _dynamic_fields[item]['purpose_field'] != 'undefined' &&
                        _dynamic_fields[item]['purpose_field']
                      }
                      {/* {
                        typeof _dynamic_fields[item]['placeholder'] != 'undefined' &&
                        _dynamic_fields[item]['placeholder']
                      } */}
                    </div>
                  </span>
                </div>
              </div>
            );
          } else if (
            _dynamic_fields[item]['type'] == 'dropdown' &&
            item != 'phone'
          ) {
            return (
              <div className="col-md-6">
                <div className="form-group country-select country_type">
                  <select
                    name={item}
                    id={item}
                    readOnly={!isedit && metadata && metadata[item]}
                    // defaultValue={(data&&data.pps_country)?data.pps_country:''}
                    className="form-control"
                  >
                    <option value="">
                      Select a {_dynamic_fields[item]['label']}
                    </option>
                    {Object.keys(_dynamic_fields[item]['range']).map(
                      (option, i) => {
                        var range = _dynamic_fields[item]['range'];
                        return (
                          <option
                            value={option}
                            selected={
                              data && option == data[item] ? true : false
                            }
                          >
                            {range[option]}
                          </option>
                        );
                      }
                    )}
                  </select>

                  <label
                    className={
                      data && data[item]
                        ? 'form-control-placeholder active'
                        : 'form-control-placeholder'
                    }
                    htmlFor={item}
                  >
                    {_dynamic_fields[item]['label']}
                  </label>


                  <div id={"label_for_" + item} class="field-info">
                    {
                      typeof _dynamic_fields[item]['purpose_field'] != 'undefined' &&
                      _dynamic_fields[item]['purpose_field']
                    }
                  </div>

                </div>
              </div>
            );
          }
        })}
        </>
    );
  }
}
export class AddLearner extends React.Component {
  constructor(props) {
    document.body.className += ' disable_background_scroll';
    super(props);

    var _info_unavail = this.props.setdata
      ? this.props.setdata.pps_info_unavailable
      : false;
    this.state = {
      id: this.props.id,
      type: this.props.type,
      countries: [],
      error: '',
      ppsswitch: 1,
      userexist: false,
      userActive: true,
      userAlreadyInWaitingList:false,
      readonly: false,
      clickedchange: false,
      setdata: this.props.setdata ? this.props.setdata : null,
      info_unavail: _info_unavail,
      learnerindex:
        this.props.learnerindex != null && this.props.learnerindex.toString()
          ? this.props.learnerindex.toString()
          : null,
      frompopup:
        this.props.frompopup != null && this.props.frompopup.toString()
          ? this.props.frompopup.toString()
          : null,
      loadingMsg: '',
      item_error: false,
      countryCode : "",
      isedit: this.props.isedit ? this.props.isedit : false
    };
    this.dissmissmodal = this.dissmissmodal.bind(this);
  }

  componentDidMount() {
    this.setState({
      countries: JSON.parse(
        localStorage.getItem('countries')
          ? localStorage.getItem('countries')
          : '[]'
      ),
    });
  }

  dissmissmodal() {
    localStorage.setItem('_metadata', '');
    document.body.className = document.body.className.replace(
      'disable_background_scroll',
      ''
    );
    this.props.dissmissmodal();
  }

  information_unaviabled = (e) => {
    var info_unavail = e.target.checked ? true : false;
    var info_unavail = e.target.checked ? true : false;

    if (info_unavail) {
      this.setState({
        info_unavail: true,
      });
    } else {
      this.setState({
        info_unavail: false,
      });
    }
  };

  loadingFormHandler = (e) => {
    this.setState({
      loadingMsg: 'Saving...',
    });
  };

  addLearnerForm = async (e) => {
    
    e.preventDefault();
    let countryCode =  document.getElementById("country_code").value;
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    let that = this;

    if(this.state.setdata.id == "" && this.state.setdata.email != ""){
      if (emailRegex.test(this.state.setdata.email)) {
        localStorage.setItem(this.state.setdata.email,document.getElementById("country_code").value);
      }
    }

    if(countryCode){
      countryCode = countryCode[0] == "+" ? countryCode.substring(1,countryCode.length) : countryCode;
      let checkCountryCode = this.state.countries.find((country)=> country.calling_code == countryCode);
      if(!checkCountryCode){
        document.getElementById("country_code").removeAttribute("readonly");
        document.getElementById("invalid_country_code").value = "invalid";
        document.getElementById("label_for_country_code").innerHTML = `<span class="error-msg" style="visibility: visible;"><span classname="error-msg-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="16.4" height="16.4" viewBox="0 0 16.4 16.4">
                <circle id="Ellipse_63" data-name="Ellipse 63" cx="7.5" cy="7.5" r="7.5" transform="translate(0.7 0.7)" fill="#fff" stroke="#e30002" stroke-width="1.4"></circle>
                <path id="Path_59" data-name="Path 59" d="M822.5,583.685v4.54" transform="translate(-814.216 -579.681)" fill="none" stroke="#e30002" stroke-linecap="round" stroke-width="2"></path>
                <path id="Path_60" data-name="Path 60" d="M822.5,583.725v-.04" transform="translate(-814.216 -572.248)" fill="none" stroke="#e30002" stroke-linecap="round" stroke-width="2.4"></path>
            </svg>
      </span>
      Invalid code.</span>`;

        return;
      }
      localStorage.setItem(`country_code_${this.state.setdata.id}`, countryCode[0] == "+"? countryCode : "+" + countryCode );

    }
    localStorage.setItem('_metadata', '');
    var errorExist = 0;
    var data = {};
    var noskip;
    var need_pps;
    var basic_needed = !__isLoggedin || _bfo;
    /*
    false - logged in  && not bfo
    true - logged in  && bfo
    true - not logged in  && not bfo
    true - not logged in  &&  bfo
    */

    if (this.state.id) {
      const item_details = CartService.getCartItem(
        this.state.type + '_' + this.state.id
      );
      need_pps = item_details.others.pps_required;
    } else {
      need_pps = CartService.is_pps_required();
    }
    var has_pps =
      e.target.has_pps && e.target.has_pps.value == '1' ? true : false;
    var info_unavail =
      e.target.pps_info_unavailable && e.target.pps_info_unavailable.checked
        ? true
        : false;
    this.setState({
      info_unavail: info_unavail,
    });
    //learner info
    var inputs = {
      id: {
        required: false,
        type: 'text',
        regx: '',
        message: '',
      },
      oldIndex: {
        required: false,
        type: 'text',
        regx: '',
        message: '',
      },
      name: {
        required: basic_needed,
        type: 'text',
        regx: /[\S\d]/,
        message: ' Please enter your First and Last Name.',
      },
      email: {
        required: basic_needed,
        type: 'text',
        regx: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        message: 'You have entered an incorrect email.',
      },
      phone: {
        // 'required': true,
        required: basic_needed && _dynamic_fields['phone']['required'],
        type: 'text',
        regx: /^[0-9]{6,20}$/,
        message: 'Enter the phone number in the correct format.',
      },
      country_code: {
        // 'required': true,
        required: basic_needed && _dynamic_fields['phone']['required'],
        type: 'text',
        regx: /^(\+?\d{1,3}|\d{1,4})$/,
        message: '',
      },
      has_pps: {
        required: need_pps,
        type: 'radio',
        regx: '',
        message: '',
      },
      pps_number: {
        required: need_pps && has_pps,
        type: 'text',
        regx: /^[a-zA-Z0-9\s.\-]+$/,
        message: 'You have entered an incorrect PPS number.',
      },
      // pps info
      pps_info_unavailable: {
        required: false,
        type: 'checkbox',
        regx: '',
        message: '',
      },
      pps_full_name: {
        required: need_pps && !has_pps && !info_unavail,
        type: 'text',
        regx: '',
        message: ' Oops! It seems like you have not filled in name',
      },
      pps_dob: {
        required: need_pps && !has_pps && !info_unavail,
        type: 'text',
        regx: '',
        message: ' Oops! It seems like you have not filled in Date of birth',
      },
      pps_country: {
        required: need_pps && !has_pps && !info_unavail,
        regx: '',
        message: ' Oops! It seems like you have not filled in Country',
      },
      pps_insurance_num: {
        required: need_pps && !has_pps && !info_unavail,
        type: 'text',
        regx: /^[0-9]+$/,
        message:
          ' Oops! It seems like you have not filled in National Insurance Number',
      },
      pps_address: {
        required: need_pps && !has_pps && !info_unavail,
        type: 'text',
        regx: '',
        message: ' Oops! It seems like you have not filled in address',
      },
      pps_contractor_full_name: {
        required: need_pps && !has_pps && !info_unavail,
        type: 'text',
        regx: '',
        message: ' Oops! It seems like you have not filled in contractor name',
      },
      pps_contractor_email: {
        required: need_pps && !has_pps && !info_unavail,
        type: 'text',
        regx: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        message: ' Oops! It seems like you have not filled in contractor email',
      },
      pps_contractor_address: {
        required: need_pps && !has_pps && !info_unavail,
        type: 'text',
        regx: '',
        message:
          ' Oops! It seems like you have not filled in contractor address',
      },
      pps_contractor_location: {
        required: need_pps && !has_pps && !info_unavail,
        type: 'text',
        regx: '',
        message:
          ' Oops! It seems like you have not filled in contractor location',
      },
      concent: {
        required: _concent.status,
        type: 'checkbox',
        regx: '',
        message: 'You can only proceed if you click the checkbox.',
      },
    };
    Object.assign(inputs, _dynamic_fields);
    inputs['phone'] = {
      required: _dynamic_fields['phone']['required'] == "1" ? true : false,
      type: 'text',
      regx: /^[0-9]{6,20}$/,
      message: 'Enter the phone number in the correct format.',
    };
    data['_dynamic'] = {};
    Object.keys(inputs).every(function (item, index) {
      // to do check setting if stp form skip or nodata skip or astrics data skip
      if (
        Object.keys(_dynamic_fields).join(',').search(item) != -1 &&
        item != 'phone'
      ) {
        if (item != 'organisation') {
          data['_dynamic'][item] = e.target[item] ? e.target[item].value : '';
          if (inputs[item].type == 'checkbox') {
            data['_dynamic'][item] = e.target[item]
              ? e.target[item].checked
              : '';
          }
        } else {
          data['_dynamic']['organisation'] = e.target['organisation']
            ? e.target['organisation'].value
            : '';
          data['_dynamic']['organisation_id'] = e.target['organisation_id']
            ? e.target['organisation_id'].value
            : '';
        }
      } else {
        data[item] = e.target[item] ? e.target[item].value : '';
        if (inputs[item].type == 'checkbox') {
          data[item] = e.target[item] ? e.target[item].checked : '';
        }
        if (item == 'email') data[item] = data[item].toLowerCase();
      }
      if (e.target[item] && e.target[item].readOnly != true) {

        if(item == "country_code" && document.getElementById("country_code_hidden")){
          let countryCode = document.getElementById("country_code_hidden").value;
          data[item] = countryCode[0] == "+" ? countryCode : "+"+countryCode;
          
          if(that.state.setdata.id == "" && that.state.setdata.email != ""){
            data[item] = localStorage.getItem(that.state.setdata.email);
          }
        }

        errorExist += field_error(e.target[item], inputs[item], null, item);

      }
      return true;
    });

    if(this.state.userActive === false){
      errorExist += field_error(e.target.email, null, {
        iserror: true,
        message: 'User Deactivated',
      }, 'email');
    }

    if(this.state.userAlreadyInWaitingList === true){
      errorExist += field_error(e.target.email, null, {
        iserror: true,
        message: 'User Already In Waiting List',
      }, 'email');
    }

    // //console.log('not skipped',errorExist);
    if (this.state.userexist)
      errorExist += field_error(e.target.email, null, {
        iserror: this.state.userexist,
        message: 'User Already subscribed',
      }, 'email');
    if (this.state.useradded)
      errorExist += field_error(e.target.email, null, {
        iserror: this.state.useradded,
        message: 'User Already added',
      }, 'email');

      if (this.state.useraddedphone)
        errorExist += field_error(e.target.phone, null, {
        iserror: this.state.useraddedphone,
        message: 'User Already added',
      }, 'phone');

    var res = await CartService.checkMobileNumber(
          data,
          this.state.type + '_' + this.state.id,
          this.state.learnerindex
        );
    if(res && res.error){
      errorExist += field_error(e.target.phone, null, {
        iserror: true,
        message: 'Phone number exist',
      }, 'phone');
    }   

    if (errorExist == 0) {
      this.loadingFormHandler();
      if (this.state.id) {
        var res = await CartService.addLearner(
          data,
          this.state.type + '_' + this.state.id,
          this.state.learnerindex,
          this.state.isedit
        );
        if(res == "phone"){
          errorExist += field_error(e.target.phone, null, {
            iserror: this.state.useraddedphone,
            message: 'User Already added',
          }, 'phone');
        }
        var mem_enabled = CartService.checkmemEnabled(
          data,
          this.state.type + '_' + this.state.id
        );
        this.dissmissmodal();
        if (mem_enabled == '1' || mem_enabled == '2') {
          this.props.show_membermsg(mem_enabled);
        } else {
          if (this.state.frompopup != 1) {
            this.props.refresh();
          }
        }
        this.setState({
          loadingMsg: '',
        });
      } else {
        // localStorage.setItem('dc_form',JSON.stringify(data));
        this.props.submit(JSON.stringify(data));
      }
    }
  };

  check_learner = (e,index="email") => {
    var skip = false;
    var pskip = false;
    // if (e.target.value) {
      var key =
        (this.state.type ? this.state.type : '') +
        '_' +
        (this.state.id ? this.state.id : '');
      var learner = Object.keys(CartService.getLearner(key));

      // edit case
      
      // let phone = ""
      // let email = ""
      
      let checkobject = {
          email : this.state.email ?? "",
          phone : this.state.phone ?? ""
        }
      
      if(index == "phone"){
       // phone = e.target.value
        pskip = this.props.setdata && this.props.setdata.phone == e.target.value;
        this.setState({ phone: e.target.value });
        checkobject.phone = e.target.value
      }
      if(index == "email"){
        //email = e.target.value
        skip = this.props.setdata && this.props.setdata.email == e.target.value;
        this.setState({ email: e.target.value });
        checkobject.email = e.target.value
      }
      
      // 1 edits email to same mail (not block)
      // edits email to another user email block
      // if(index == "email"){

      if (
        JSON.stringify(learner)
          .toLowerCase()
          .search(
            e.target.value.toLowerCase().replace(/[^A-Za-z0-9_]/g, '\\$&') + '"'
          ) != -1 &&
        !skip
      ) {
        var error_index = 'email';
        var message = 'User already added';
        var error = field_error(e.target, null, { iserror: true, message }, error_index);
        this.setState({
          event_warning: false,
          useradded: true,
        },);
        return;
      } else {
        var error_index = 'email';
        var message = 'User already added';
        var error = field_error(e.target, null, { iserror: false, message }, error_index);
        this.setState({
          useradded: false,
        });
      }
   // }
    // if(index == "phone"){

    
    //   if (
    //     JSON.stringify(learner)
    //       .toLowerCase()
    //       .search(
    //         checkobject.phone.toLowerCase().replace(/[^A-Za-z0-9_]/g, '\\$&') + '"'
    //       ) != -1 &&
    //     !pskip
    //   ) {
    //     var error_index = 'phone';
    //     var message = 'User already added';
    //     var error = field_error(e.target, null, { iserror: true, message }, error_index);
    //     this.setState({
    //       event_warning: false,
    //       useradded: true,
    //     },);
    //     return;
    //   } else {
    //     var error_index = 'phone';
    //     var message = 'User already added';
    //     var error = field_error(e.target, null, { iserror: false, message }, error_index);
    //     this.setState({
    //       useradded: false,
    //     });
    //   }
    // }
      fetch(api_url + '/check_learner', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          api: true,
          email: checkobject.email ?? "",
          phone: checkobject.phone ?? "",
          id: this.state.id ? this.state.id : '',
          type: this.state.type ? this.state.type : '',
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          // //console.log(result);
          if(result && result.error && result.error == true && result.msg == "User Deactivated"){
            this.setState({
              userActive:false
            });
          }else{
            this.setState({
              userActive:true
            });
          }
          if(result && result.error && result.error == true && result.msg == "User Already In Waiting List"){
            this.setState({
              userAlreadyInWaitingList:true
            });
          }else{
            this.setState({
              userAlreadyInWaitingList:false
            });
          }
          if (!result.error && result.data) {
            var user = {
              id: result.data.id,
              name: result.data.name,
              email: result.data.email,
              phone: result.data.phone,
              country_code: result.data.country_code,
              has_pps: result.data.has_pps,
              pps_number: result.data.pps_number,
              pps_info_unavailable: result.data.pps_info_unavailable,
              pps_full_name: result.data.pps_full_name,
              pps_dob: result.data.pps_dob,
              pps_country: result.data.pps_country,
              pps_insurance_num: result.data.pps_insurance_num,
              pps_address: result.data.pps_address,
              pps_contractor_full_name: result.data.pps_contractor_full_name,
              pps_contractor_email: result.data.pps_contractor_email,
              pps_contractor_address: result.data.pps_contractor_address,
              pps_contractor_location: result.data.pps_contractor_location,
              _dynamic: result.data._dynamic,
            };
            document.getElementById("country_code_hidden").value = result.data.country_code;
            localStorage.setItem(`country_code_${result.data.id}`,result.data.country_code);
            // set metadata
            if (this.state.id) {
              CartService.save_metadata(
                this.state.type + '_' + this.state.id,
                user
              );
            } else {
              localStorage.setItem('_metadata', JSON.stringify(user));
            }

            this.setState({
              event_warning: result.warning,
              setdata: user,
              info_unavail: result.data.pps_info_unavailable,
              readonly: true,
              ppsswitch: result.data.has_pps,
              userexist: false,
            });
          } else if (!result.error) {
            // reset metadata
            let isEdit  = this.state.isedit;
            let setData = this.state.setdata;
            var user = {
              id: '',
              name: isEdit ? setData?.name : '',
              email: result?.email,
              phone: isEdit ? setData?.phone : '',
              country_code: isEdit ? setData?.country_code : '',
              has_pps: isEdit ? setData?.has_pps : '',
              pps_number: isEdit ? setData?.pps_number : '',
              pps_info_unavailable: isEdit ? setData?.pps_info_unavailable : '',
              pps_full_name: isEdit ? setData?.pps_info_unavailable : '',
              pps_dob: isEdit ? setData?.pps_dob : '',
              pps_country: isEdit ? setData?.pps_country : '',
              pps_insurance_num: isEdit ? setData?.pps_insurance_num : '',
              pps_address: isEdit ? setData?.pps_address : '',
              pps_contractor_full_name: isEdit ? setData?.pps_contractor_full_name : '',
              pps_contractor_email: isEdit ? setData?.pps_contractor_email : '',
              pps_contractor_address: isEdit ? setData?.pps_contractor_address : '',
              pps_contractor_location: isEdit ? setData?.pps_contractor_location : '',
              _dynamic: isEdit ? setData?._dynamic : '',
            };
            if (this.state.id) {
              CartService.save_metadata(
                this.state.type + '_' + this.state.id,
                user
              );
            } else {
              localStorage.setItem('_metadata', JSON.stringify(user));
            }
            this.setState({
              event_warning: result.warning,
              setdata: user,
              info_unavail: false,
              readonly: false,
              userexist: false,
            });
          } else {
            this.setState({
              event_warning: result.warning,
              userexist: true,
            });
          }
        })
        .then(() => {
          Yes;

          var error_index = 'email';
          var message = 'User already Subscribed';
          var error = field_error(e.target, null, {
            iserror: this.state.userexist,
            message,
          }, 'email');
          if (!error) {
            var event_message = {
              0: '',
              1: 'Oops! You got another event of the same course.',
              2: 'Oops! You got another event on the same date.',
              3: 'Oops! You got another event on the same date and under same course',
            };
            var error = warning(e.target, null, {
              iserror: this.state.event_warning != 0,
              message: event_message[this.state.event_warning],
            });
          }
          
        })
        .catch((error) => {
          //console.log(error);
        });
    // }
  };



  check_learner2 = (e,index1="phone") => {

    var skip = false;
    var pskip = false;
    if (e.target.value) {
      var key =
        (this.state.type ? this.state.type : '') +
        '_' +
        (this.state.id ? this.state.id : '');
        var cart = localStorage.getItem('mycart');
        let learner = "";
        if (_buyNow) {
          cart = {};
          cart[_buyNow] = _buyNowDetails;
          learner =  cart[_buyNow] ? cart[_buyNow].learners : [];
        }
        else{
          if (cart == '[]' || cart == '{}' || !cart){
            learner =""
          }
          else {
            cart = JSON.parse(localStorage.getItem('mycart'));
            learner = cart[key] ? cart[key].learners : [];
          }
        }
        
     // var learner = Object.keys(CartService.getLearner(key));
      let checkobject = {
          email : this.state.email ?? "",
          phone : this.state.phone ?? ""
        }
      
      if(index1 == "phone"){
       // phone = e.target.value
        pskip = this.props.setdata && this.props.setdata.phone == e.target.value;
        this.setState({ phone: e.target.value });
        checkobject.phone = e.target.value
      }
      if(index1 == "email"){
        //email = e.target.value
        skip = this.props.setdata && this.props.setdata.email == e.target.value;
        this.setState({ email: e.target.value });
        checkobject.email = e.target.value
      }

      const propertyNames = Object.values(learner);
      let obj = propertyNames.find(o => o.phone == checkobject.phone);
      if(obj && !skip){
        var error_index = 'phone';
        var message = 'User already added';
        var error = field_error(e.target, null, { iserror: true, message }, error_index);
        this.setState({
          event_warning: false,
          useraddedphone: true,
        })
      }
      else{
        var error_index = 'phone';
        var message = 'User already added';
        var error = field_error(e.target, null, { iserror: false, message }, error_index);
        this.setState({
          event_warning: false,
          useraddedphone: false,
        })
      }
      fetch(api_url + '/check_learner', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          api: true,
          email: checkobject.email ?? "",
          phone: checkobject.phone ?? "",
          id: this.state.id ? this.state.id : '',
          type: this.state.type ? this.state.type : '',
        }),
      })
      .then((res) => res.json())
      .then((res) => {
        if(res.error){
          var error_index = 'phone';
          var message = 'User already Subscribed';
          var error = field_error(e.target, null, {
            iserror: this.state.userexist,
            message,
          }, 'phone');
        }
        else{
          this.setState({
            event_warning: false,
            userexist: false,
          });
          // var error_index = 'email';
          // var message = 'User already Subscribed';
          // var error = field_error(e.target, null, { iserror: false, message }, error_index);
        }
        // e.target = document.getElementById('addLearnerForm');
        
      })
      
      .catch((error) => {
        //console.log(error);
      });
      // if (
      //   JSON.stringify(learner)
      //     .toLowerCase()
      //     .search(
      //       checkobject.phone.toLowerCase().replace(/[^A-Za-z0-9_]/g, '\\$&') + '"'
      //     ) != -1 &&
      //   !skip
      // ) {
      //   var error_index = 'phone';
      //   var message = 'User already added';
      //   var error = field_error(e.target, null, { iserror: true, message }, error_index);
      //   this.setState({
      //     event_warning: false,
      //     useradded: true,
      //   },);
      //   return;
      // } else {
      //   var error_index = 'phone';
      //   var message = 'User already added';
      //   var error = field_error(e.target, null, { iserror: false, message }, error_index);
      //   this.setState({
      //     useradded: false,
      //   });
      // }       
    }
  };




  changepps = (e) => {
    if (e.target.value != this.state.ppsswitch) {
    }
    this.setState({
      ppsswitch: e.target.value,
      clickedchange: true,
    });
  };

  changefn = (e) => {
    // parent class change handler is always called with field name and value
    this.setState({[e.target.name]: e.target.value});
  }

  changeCountryCode = (e) =>{
    document.getElementById("country_code").removeAttribute("readonly");
    document.getElementById("country_code_hidden").value = e.target.value;
    localStorage.setItem(`country_code_${this.state.setdata.id}`,e.target.value);
    if(this.state.setdata.id == "" && this.state.setdata.email != ""){
      localStorage.setItem(this.state.setdata.email,e.target.value);
    }
  }

  render() {
    let data   = this.state.setdata;
    let isEdit = this.state.isedit;
    
    if(data && data.id){
      data.country_code = localStorage.getItem(`country_code_${data.id}`);
    }
    if(data && data.id == "" && data.email != "" && localStorage.getItem(data.email)){
      data.country_code = localStorage.getItem(data.email);
    }
    var readonly = this.state.readonly;
    var info_unavail = this.state.info_unavail;
    const basic_needed = !__isLoggedin || _bfo;
    if (data && data.pps_info_unavailable != '')
      info_unavail = data.pps_info_unavailable;
    var pps_enabled,
      _metadata = null;
    if (this.state.id) {
      const item_details = CartService.getCartItem(
        this.state.type + '_' + this.state.id
      );
      pps_enabled = item_details.others.pps_required;
      if (data) {
        _metadata = CartService.get_metadata(
          this.state.type + '_' + this.state.id
        );
        if (_metadata) {
          _metadata = _metadata[data.email];
        }
      }
    } else {
      if (!this.state.id) {
        _metadata = localStorage._metadata
          ? JSON.parse(localStorage._metadata)
          : null;
      }
      pps_enabled = CartService.is_pps_required();
    }

    var __has_pps;
    if (data && data.has_pps !== '' && !this.state.clickedchange) {
      __has_pps = data && data.has_pps == '1' ? true : false;
    } else {
      this.state.clickedchange = false;
      __has_pps =
        this.state.ppsswitch == 1 || this.state.ppsswitch == '' ? true : false;
      // if(data && data.has_pps =='' &&!this.state.clickedchange)
      // {
      // 	console.log('state',_metadata.has_pps,data.has_pps);
      // 	__has_pps = true;
      // }
    }
    var rankey = Math.random();
    var __loaded_from_server =
      _metadata && _metadata.has_pps !== '' ? true : false;
    const section = document.querySelector( '.error-msg' );
    if(section){
      section.scrollIntoView( { behavior: 'smooth', block: 'start' } ); 
    }
    
    return (
      <div
        className="modal add_address_form show fade in"
        id="details-pps"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
          <input
                      type="hidden"
                      name="id"
                      id = "country_code_hidden"
                    />
        <div className="pps-details-sec">
          <form
            action="#"
            method="post"
            // action="#"
            id="addLearnerForm"
            onSubmit={this.addLearnerForm}
          >
            <div className="pps-form-header">
              <button
                type="button"
                className="close cart-close"
                onClick={this.dissmissmodal}
              >
                ×
              </button>
              <h5>Learner Details</h5>
              <p className="pr-4">
                {/* Personal Public Service Number (PPSN) is a unique reference number given{" "} */}
                Enter the specific details of the new learner in the column
                below. Click the checkbox to add the new learner.
              </p>
            </div>
            <div className="learnerwrapper row">
            {basic_needed == 1 && (
            
              <div className="col-md-6">
                <div
                  key={data && data.name ? data.name : ''}
                  className="form-group form-group-alter "
                >
                  <span>
                    <label className={data && data.name || this.state.name ? 'active' : ''} style={{'text-transform': 'none'}}>
                      Full Name
                    </label>
                    <input
                      type="text"
                      autocomplete="off"
                      name="name"
                      id="name"
                      readOnly={!isEdit && _metadata && _metadata.name}
                      defaultValue={data && data.name ? data.name : ''}
                      className="form-control form-alter"                     
                      onChange={this.changefn}
                    />
                    <input
                      type="hidden"
                      name="id"
                      readOnly={_metadata && _metadata.id}
                      defaultValue={data && data.id ? data.id : ''}
                    />
                    <input
                      type="hidden"
                      id = "invalid_country_code"
                    />
                    <input
                      type="hidden"
                      name="oldIndex"
                      readOnly="readOnly"
                      defaultValue={
                        this.state.learnerindex ? this.state.learnerindex : ''
                      }
                    />
                    <div id="label_for_name" class="field-info"></div>
                  </span>
                </div>
              </div>
            )}
            {basic_needed == 1 && (
              <div className="col-md-6">
                <div className="form-group form-group-alter ">
                  <span>
                    <label className={data && data.email  || this.state.email ? 'active' : ''}>
                      Email Address
                    </label>
                    <input
                      autocomplete="off"
                      type="text"
                      name="email"
                      //
                      defaultValue={data && data.email ? data.email : ''}
                      onChange={(e) => setTimeout(() => {
                        this.check_learner(e,"email")
                      }, 200) }
                      className="form-control form-alter"
                    />
                    <label className="info-label"></label>
                    <div id="label_for_email" class="field-info"></div>
                  </span>
                </div>
              </div>
            )}
            {/* {basic_needed == 1 && <div className="col-md-6 pl-0 pr-1"
							style={{ "width": "65px" }}>
							<div  className="form-group form-group-alter ">
								<span>
									<input
										type="text"
										name="country_code"
										maxLength={10}
										readOnly={_metadata && _metadata.country_code}
										defaultValue={(data && data.country_code) ? data.country_code : ''}
										className="form-control form-alter"
									/>
								</span>
							</div>
						</div>} */}
            {basic_needed == 1 && (
              <div className="col-md-6">
                <div className="form-group form-group-alter phone-number">
                  <span className="select-code" key={rankey}>
                    <label
                      className={
                        data && data.country_code || this.state.country_code
                          ? 'active'
                          : _userCountryCode
                            ? 'active'
                            : ''
                      }
                    >
                      Code
                    </label>
                    <input
                      type="text"
                      name="country_code"
                      id="country_code"
                      maxLength={10}
                      readOnly={!isEdit && _metadata && _metadata.country_code}
                      onChange = {this.changeCountryCode}
                      defaultValue={
                        data && data.country_code
                          ? data.country_code
                          : _userCountryCode
                            ? '+' + _country[_userCountryCode].calling_code
                            : ''
                      }
                      className="form-control form-alter"
                    />
                    <div id="label_for_country_code" class="field-info"></div>
                  </span>
                  <span
                    className="number"
                    key={data && data.phone ? data.phone : ''}
                  >
                    <label className={data && data.phone || this.state.phone ? 'active' : ''}>
                      Phone Number
                    </label>
                    <input
                      // type="number"
                      type={_metadata && _metadata.phone ? 'text' : 'number'}
                      name="phone"
                      maxLength={10}
                      readOnly={!isEdit && _metadata && _metadata.phone}
                      defaultValue={data && data.phone ? data.phone : ''}
                      className="form-control form-alter"
                      onChange={this.changefn}
                      // onChange={(e) => this.check_learner2(e,"phone")}
                    />
                    <div id="label_for_phone" class="field-info"></div>
                  </span>
                </div>
              </div>
            )}
            <Dynamic_field
              key={data && data._dynamic ? data._dynamic : ''}
              metadata={
                _metadata && _metadata._dynamic ? _metadata._dynamic : null
              }
              data={data && data._dynamic ? data._dynamic : null}
              isEdit={isEdit}
            />

            {/* {dynamic_fields()} */}
            {pps_enabled && (
              <div className="col-md-12 p-0">
                <span className="coupon-subtxt m-0">
                  Do you have a PPS number?
                </span>
                <div
                  className="d-flex mt-05 ppc-choose"
                  style={{
                    'pointer-events': __loaded_from_server ? 'none' : 'auto',
                  }}
                >
                  <span>
                    <input
                      key={rankey}
                      type="radio"
                      id="pps_yes"
                      className="pps_radio"
                      name="has_pps"
                      defaultValue={1}
                      onClick={this.changepps}
                      // readOnly={_metadata && _metadata.has_pps}
                      defaultChecked={__has_pps}
                    // defaultChecked={(data && data.has_pps == '1') ? true : ((!data) ? true : false)}
                    />
                    <label htmlFor="pps_yes">Yes</label>
                  </span>
                  <span className="no-ppc-sec">
                    <input
                      key={rankey}
                      type="radio"
                      id="pps_no"
                      className="pps_radio"
                      defaultValue={0}
                      onClick={this.changepps}
                      name="has_pps"
                      // readOnly={_metadata && _metadata.has_pps}
                      defaultChecked={!__has_pps}
                    // defaultChecked={(data && data.has_pps == '0') ? true : false}
                    />
                    <label htmlFor="pps_no">No</label>
                  </span>
                </div>
              </div>
            )}

            {pps_enabled && (
              <div
                className="pps-member-sec"
                id="pps_number_form"
                style={__has_pps ? { display: 'block' } : { display: 'none' }}
              >
                {/* style={data && !data.has_pps?{ display: "none" }:{display:'block'}}> */}
                <div className="col-md-9 pl-0 pr-2 sm-pd-0">
                  <div className="form-group form-group-alter ">
                    <span>
                      <label
                        className={data && data.pps_number ? 'active' : ''}
                      >
                        PPS Number
                      </label>
                      <input
                        type="text"
                        name="pps_number"
                        readOnly={_metadata && _metadata.pps_number}
                        // readOnly={readonly && (data && data.pps_number) ? data.pps_number : ''}
                        defaultValue={
                          data && data.pps_number ? data.pps_number : ''
                        }
                        className="form-control form-alter"
                      />
                    </span>
                  </div>
                </div>
              </div>
            )}

            {pps_enabled && (
              <div
                className="pps-no-member-sec mt-05"
                id="pps_detailed_form"
                style={!__has_pps ? { display: 'block' } : { display: 'none' }}
              // style={data && data.has_pps?{ display: "none" }:{display:'block'}}
              >
                <span className="coupon-subtxt">Enter STB Form</span>
                <span
                  key={rankey}
                  className="info-checkbox"
                  style={{
                    'pointer-events':
                      _metadata && _metadata.pps_info_unavailable !== ''
                        ? 'none'
                        : 'auto',
                  }}
                >
                  <input
                    name="pps_info_unavailable"
                    defaultChecked={info_unavail}
                    onChange={this.information_unaviabled}
                    type="checkbox"
                  />{' '}
                  Information Unavailable
                </span>
                <span className="cart-sub-text">Candidate Details</span>
                <div className="row">
                  <div className="col-md-6 pr-1">
                    <div className="form-group">
                      <input
                        type="text"
                        name="pps_full_name"
                        readOnly={
                          (_metadata && _metadata.pps_full_name) || info_unavail
                        }
                        defaultValue={
                          data && data.pps_full_name ? data.pps_full_name : ''
                        }
                        id="pps_full_name"
                        className="form-control"
                      // required
                      />
                      <label
                        className={
                          data && data.pps_full_name
                            ? 'form-control-placeholder active'
                            : 'form-control-placeholder'
                        }
                        htmlFor="pps_full_name" style={{'text-transform': 'none'}}
                      >
                        First and Last Name
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6 pl-1 pd-sm">
                    <div className="form-group dob-select">
                      <input
                        name="pps_dob"
                        id="pps_dob"
                        className="form-control"
                        // required
                        type={_metadata && _metadata.pps_dob ? 'text' : 'date'}
                        readOnly={
                          (_metadata && _metadata.pps_dob) || info_unavail
                        }
                        defaultValue={data && data.pps_dob ? data.pps_dob : ''}
                      />
                      <label
                        // className="form-control-placeholder"
                        className={
                          data && data.pps_dob
                            ? 'form-control-placeholder  date-label active'
                            : 'form-control-placeholder  date-label'
                        }
                        htmlFor="pps_dob"
                      >
                        DOB
                      </label>
                      <svg
                        className="dob-svg"
                        xmlSpace="preserve"
                        enableBackground="new 0 0 30 30"
                        viewBox="0 0 1000 1000"
                        y="0px"
                        x="0px"
                        version="1.1"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ height: 41, width: 15 }}
                      >
                        <g>
                          <path d="M867.2,131.4h-58.5V53.6c0-24.6-20.2-44.8-44.8-44.8h-2.4c-24.6,0-44.8,20.2-44.8,44.8v77.8h-430V53.6c0-24.6-20.2-44.8-44.8-44.8h-2.4c-24.6,0-44.8,20.2-44.8,44.8v77.8h-61.9C65.3,131.4,10,186.7,10,254.2v614.1c0,67.6,55.3,122.8,122.8,122.8h734.4c67.6,0,122.8-55.3,122.8-122.8V254.2C990,186.7,934.7,131.4,867.2,131.4z M900.4,899H100.8V407.8h799.6V899z M900.4,314.4H100.8V221h799.6V314.4z" />
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 pr-1">
                    <div className="form-group country-select country_type">
                      <select
                        name="pps_country"
                        id="pps_country"
                        readOnly={
                          (_metadata && _metadata.pps_country) || info_unavail
                        }
                        // defaultValue={(data&&data.pps_country)?data.pps_country:''}
                        className="form-control"
                      >
                        <option value="">Select a country</option>
                        {this.state.countries.map((item, i) => {
                          return (
                            <option
                              value={item.id}
                              selected={
                                data && item.id == data.pps_country
                                  ? true
                                  : false
                              }
                            >
                              {item.country_name}
                            </option>
                          );
                        })}
                      </select>

                      <label
                        className={
                          data && data.pps_country
                            ? 'form-control-placeholder active'
                            : 'form-control-placeholder'
                        }
                        htmlFor="pps_country"
                      >
                        Country
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6 pl-1 pd-sm">
                    <div className="form-group">
                      <input
                        type={
                          _metadata && _metadata.pps_insurance_num
                            ? 'text'
                            : 'number'
                        }
                        name="pps_insurance_num"
                        readOnly={
                          (_metadata && _metadata.pps_insurance_num) ||
                          info_unavail
                        }
                        defaultValue={
                          data && data.pps_insurance_num
                            ? data.pps_insurance_num
                            : ''
                        }
                        id="pps_insurance_num"
                        className="form-control"
                      // required
                      />
                      <label
                        className={
                          data && data.pps_insurance_num
                            ? 'form-control-placeholder active'
                            : 'form-control-placeholder'
                        }
                        htmlFor="pps_insurance_num"
                      >
                        National Insurance Number
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        name="pps_address"
                        readOnly={
                          (_metadata && _metadata.pps_address) || info_unavail
                        }
                        defaultValue={
                          data && data.pps_address ? data.pps_address : ''
                        }
                        id="pps_address"
                        className="form-control"
                      // required
                      />
                      <label
                        className={
                          data && data.pps_address
                            ? 'form-control-placeholder active'
                            : 'form-control-placeholder'
                        }
                        htmlFor="pps_address"
                      >
                        Address
                      </label>
                    </div>
                  </div>
                </div>
                <span className="cart-sub-text">Contractor Details</span>
                <div className="row">
                  <div className="col-md-6 pr-1">
                    <div className="form-group">
                      <input
                        type="text"
                        name="pps_contractor_full_name"
                        readOnly={
                          (_metadata && _metadata.pps_contractor_full_name) ||
                          info_unavail
                        }
                        defaultValue={
                          data && data.pps_contractor_full_name
                            ? data.pps_contractor_full_name
                            : ''
                        }
                        id="pps_contractor_full_name"
                        className="form-control"
                      // required
                      />
                      <label
                        className={
                          data && data.pps_contractor_full_name
                            ? 'form-control-placeholder active'
                            : 'form-control-placeholder'
                        }
                        htmlFor="pps_contractor_full_name" style={{'text-transform': 'none'}}
                      >
                        First and Last Name
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6 pl-1 pd-sm">
                    <div className="form-group">
                      <input
                        type="text"
                        name="pps_contractor_email"
                        readOnly={
                          (_metadata && _metadata.pps_contractor_email) ||
                          info_unavail
                        }
                        defaultValue={
                          data && data.pps_contractor_email
                            ? data.pps_contractor_email
                            : ''
                        }
                        id="pps_contractor_email"
                        className="form-control"
                      // required
                      />
                      <label
                        className={
                          data && data.pps_contractor_email
                            ? 'form-control-placeholder active'
                            : 'form-control-placeholder'
                        }
                        htmlFor="pps_contractor_email"
                      >
                        Email Address
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        name="pps_contractor_address"
                        readOnly={
                          (_metadata && _metadata.pps_contractor_email) ||
                          info_unavail
                        }
                        defaultValue={
                          data && data.pps_contractor_address
                            ? data.pps_contractor_address
                            : ''
                        }
                        id="pps_contractor_address"
                        className="form-control"
                      // required
                      />
                      <label
                        className={
                          data && data.pps_contractor_address
                            ? 'form-control-placeholder active'
                            : 'form-control-placeholder'
                        }
                        htmlFor="pps_contractor_address"
                      >
                        Address (in Ireland)
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        name="pps_contractor_location"
                        readOnly={
                          (_metadata && _metadata.pps_contractor_email) ||
                          info_unavail
                        }
                        defaultValue={
                          data && data.pps_contractor_location
                            ? data.pps_contractor_location
                            : ''
                        }
                        id="pps_contractor_location"
                        className="form-control"
                      // required
                      />
                      <label
                        className={
                          data && data.pps_contractor_location
                            ? 'form-control-placeholder active'
                            : 'form-control-placeholder'
                        }
                        htmlFor="pps_contractor_location"
                      >
                        Site Location (in Ireland)
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {_concent.status && (
              <div className="declaration-box">
                <div className="cart_purchase_info">
                  {_concent.purchase_concerns_request}
                </div>
                <span className="info-checkbox">
                  <input
                    name="concent"
                    value="1"
                    type="checkbox"
                    defaultChecked={this.props.setdata ? true : false}
                  />
                  <span>
                    {_concent.purchase_concerns_response}
                    <div
                      class="cart_purchase_info"
                      dangerouslySetInnerHTML={{
                        __html: _concent.purchase_concerns_description,
                      }}
                    ></div>
                  </span>
                </span>
              </div>
            )}
            </div>
            {this.state.id && (
              <div className="bulk-cart-btn">
                <div className="btn cart-btn h-45 mt-2 theme-blue-btn1 w-75 mr-center-align">
                  {/* <a href="javascript:void(0)" id="pps_form_btn">
							Add Address
						</a> */}
                  <button
                    className="leanerbutton"
                    id="pps_form_btn"
                    type="submit"
                  >
                    {this.state.loadingMsg == ''
                      ? this.props.setdata && this.props.setdata.email
                        ? 'Save Learner'
                        : 'Add Learner'
                      : this.state.loadingMsg}
                    {/* Save Learner   */}
                  </button>
                </div>
              </div>
            )}
            
            {!this.state.id && (
              <div className="bulk-cart-btn">
                <div className="btn cart-btn h-45 mt-2 theme-blue-btn1 w-75 mr-center-align">
                  <button
                    id="pps_form_btn"
                    type="submit"
                    className="proceed-btn orange-flat-btn proceedsubmit"
                  >
                    Proceed
                  </button>
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    );
  }
}

export class AddWaitingList extends React.Component {
  constructor(props) {
    document.body.className += ' disable_background_scroll';
    super(props);

    var _info_unavail = this.props.setdata
      ? this.props.setdata.pps_info_unavailable
      : false;
    this.state = {
      id: this.props.id,
      type: this.props.type,
      countries: [],
      error: '',
      ppsswitch: 1,
      userexist: false,
      userActive: true,
      userAlreadyInWaitingList:false,
      readonly: false,
      clickedchange: false,
      setdata: this.props.setdata ? this.props.setdata : null,
      info_unavail: _info_unavail,
      learnerindex:
        this.props.learnerindex != null && this.props.learnerindex.toString()
          ? this.props.learnerindex.toString()
          : null,
      frompopup:
        this.props.frompopup != null && this.props.frompopup.toString()
          ? this.props.frompopup.toString()
          : null,
      loadingMsg: '',
      item_error: false,
      countryCode : "",
      isedit: this.props.isedit ? this.props.isedit : false,
    };
    this.dissmisswaitmodal = this.dissmisswaitmodal.bind(this);
  }

  componentDidMount() {
    this.setState({
      countries: JSON.parse(
        localStorage.getItem('countries')
          ? localStorage.getItem('countries')
          : '[]'
      ),
    });
  }

  dissmisswaitmodal() {
    localStorage.setItem('_metadata', '');
    document.body.className = document.body.className.replace(
      'disable_background_scroll',
      ''
    );
    this.props.dissmisswaitmodal();
  }

  information_unaviabled = (e) => {
    var info_unavail = e.target.checked ? true : false;
    var info_unavail = e.target.checked ? true : false;

    if (info_unavail) {
      this.setState({
        info_unavail: true,
      });
    } else {
      this.setState({
        info_unavail: false,
      });
    }
  };

  loadingFormHandler = (e) => {
    this.setState({
      loadingMsg: 'Saving...',
    });
  };

  addLearnerForm = async (e) => {
    
    e.preventDefault();
    let countryCode =  document.getElementById("country_code").value;
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    let that = this;

    if(this.state.setdata.id == "" && this.state.setdata.email != ""){
      if (emailRegex.test(this.state.setdata.email)) {
        localStorage.setItem(this.state.setdata.email,document.getElementById("country_code").value);
      }
    }

    if(countryCode){
      countryCode = countryCode[0] == "+" ? countryCode.substring(1,countryCode.length) : countryCode;
      let checkCountryCode = this.state.countries.find((country)=> country.calling_code == countryCode);
      if(!checkCountryCode){
        document.getElementById("country_code").removeAttribute("readonly");
        document.getElementById("invalid_country_code").value = "invalid";
        document.getElementById("label_for_country_code").innerHTML = `<span class="error-msg" style="visibility: visible;"><span classname="error-msg-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="16.4" height="16.4" viewBox="0 0 16.4 16.4">
                <circle id="Ellipse_63" data-name="Ellipse 63" cx="7.5" cy="7.5" r="7.5" transform="translate(0.7 0.7)" fill="#fff" stroke="#e30002" stroke-width="1.4"></circle>
                <path id="Path_59" data-name="Path 59" d="M822.5,583.685v4.54" transform="translate(-814.216 -579.681)" fill="none" stroke="#e30002" stroke-linecap="round" stroke-width="2"></path>
                <path id="Path_60" data-name="Path 60" d="M822.5,583.725v-.04" transform="translate(-814.216 -572.248)" fill="none" stroke="#e30002" stroke-linecap="round" stroke-width="2.4"></path>
            </svg>
      </span>
      Invalid code.</span>`;

        return;
      }
      localStorage.setItem(`country_code_${this.state.setdata.id}`, countryCode[0] == "+"? countryCode : "+" + countryCode );

    }
    localStorage.setItem('_metadata', '');
    var errorExist = 0;
    var data = {};
    data.addToWaitingListStatus = this.props.addToWaitingListStatus;
    var noskip;
    var need_pps;
    var basic_needed = !__isLoggedin || _bfo;
    /*
    false - logged in  && not bfo
    true - logged in  && bfo
    true - not logged in  && not bfo
    true - not logged in  &&  bfo
    */

    if (this.state.id) {
      const item_details = CartService.getCartItem(
        this.state.type + '_' + this.state.id
      );
      need_pps = item_details.others.pps_required;
    } else {
      need_pps = CartService.is_pps_required();
    }
    var has_pps =
      e.target.has_pps && e.target.has_pps.value == '1' ? true : false;
    var info_unavail =
      e.target.pps_info_unavailable && e.target.pps_info_unavailable.checked
        ? true
        : false;
    this.setState({
      info_unavail: info_unavail,
    });
    //learner info
    var inputs = {
      id: {
        required: false,
        type: 'text',
        regx: '',
        message: '',
      },
      oldIndex: {
        required: false,
        type: 'text',
        regx: '',
        message: '',
      },
      name: {
        required: basic_needed,
        type: 'text',
        regx: /[\S\d]/,
        message: ' Please enter your First and Last Name.',
      },
      email: {
        required: basic_needed,
        type: 'text',
        regx: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        message: 'You have entered an incorrect email.',
      },
      phone: {
        // 'required': true,
        required: basic_needed && _dynamic_fields['phone']['required'],
        type: 'text',
        regx: /^[0-9]{6,20}$/,
        message: 'Enter the phone number in the correct format.',
      },
      country_code: {
        // 'required': true,
        required: basic_needed && _dynamic_fields['phone']['required'],
        type: 'text',
        regx: /^(\+?\d{1,3}|\d{1,4})$/,
        message: '',
      },
      has_pps: {
        required: need_pps,
        type: 'radio',
        regx: '',
        message: '',
      },
      pps_number: {
        required: need_pps && has_pps,
        type: 'text',
        regx: /^[a-zA-Z0-9\s.\-]+$/,
        message: 'You have entered an incorrect PPS number.',
      },
      // pps info
      pps_info_unavailable: {
        required: false,
        type: 'checkbox',
        regx: '',
        message: '',
      },
      pps_full_name: {
        required: need_pps && !has_pps && !info_unavail,
        type: 'text',
        regx: '',
        message: ' Oops! It seems like you have not filled in name',
      },
      pps_dob: {
        required: need_pps && !has_pps && !info_unavail,
        type: 'text',
        regx: '',
        message: ' Oops! It seems like you have not filled in Date of birth',
      },
      pps_country: {
        required: need_pps && !has_pps && !info_unavail,
        regx: '',
        message: ' Oops! It seems like you have not filled in Country',
      },
      pps_insurance_num: {
        required: need_pps && !has_pps && !info_unavail,
        type: 'text',
        regx: /^[0-9]+$/,
        message:
          ' Oops! It seems like you have not filled in National Insurance Number',
      },
      pps_address: {
        required: need_pps && !has_pps && !info_unavail,
        type: 'text',
        regx: '',
        message: ' Oops! It seems like you have not filled in address',
      },
      pps_contractor_full_name: {
        required: need_pps && !has_pps && !info_unavail,
        type: 'text',
        regx: '',
        message: ' Oops! It seems like you have not filled in contractor name',
      },
      pps_contractor_email: {
        required: need_pps && !has_pps && !info_unavail,
        type: 'text',
        regx: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        message: ' Oops! It seems like you have not filled in contractor email',
      },
      pps_contractor_address: {
        required: need_pps && !has_pps && !info_unavail,
        type: 'text',
        regx: '',
        message:
          ' Oops! It seems like you have not filled in contractor address',
      },
      pps_contractor_location: {
        required: need_pps && !has_pps && !info_unavail,
        type: 'text',
        regx: '',
        message:
          ' Oops! It seems like you have not filled in contractor location',
      },
      concent: {
        required: _concent.status,
        type: 'checkbox',
        regx: '',
        message: 'You can only proceed if you click the checkbox.',
      },
    };
    Object.assign(inputs, _dynamic_fields);
    inputs['phone'] = {
      required: _dynamic_fields['phone']['required'] == "1" ? true : false,
      type: 'text',
      regx: /^[0-9]{6,20}$/,
      message: 'Enter the phone number in the correct format.',
    };
    data['_dynamic'] = {};
    Object.keys(inputs).every(function (item, index) {
      // to do check setting if stp form skip or nodata skip or astrics data skip
      if (
        Object.keys(_dynamic_fields).join(',').search(item) != -1 &&
        item != 'phone'
      ) {
        if (item != 'organisation') {
          data['_dynamic'][item] = e.target[item] ? e.target[item].value : '';
          if (inputs[item].type == 'checkbox') {
            data['_dynamic'][item] = e.target[item]
              ? e.target[item].checked
              : '';
          }
        } else {
          data['_dynamic']['organisation'] = e.target['organisation']
            ? e.target['organisation'].value
            : '';
          data['_dynamic']['organisation_id'] = e.target['organisation_id']
            ? e.target['organisation_id'].value
            : '';
        }
      } else {
        data[item] = e.target[item] ? e.target[item].value : '';
        if (inputs[item].type == 'checkbox') {
          data[item] = e.target[item] ? e.target[item].checked : '';
        }
        if (item == 'email') data[item] = data[item].toLowerCase();
      }
      if (e.target[item] && e.target[item].readOnly != true) {

        if(item == "country_code" && document.getElementById("country_code_hidden")){
          let countryCode = document.getElementById("country_code_hidden").value;
          data[item] = countryCode[0] == "+" ? countryCode : "+"+countryCode;
          
          if(that.state.setdata.id == "" && that.state.setdata.email != ""){
            data[item] = localStorage.getItem(that.state.setdata.email);
          }
        }

        errorExist += field_error(e.target[item], inputs[item], null, item);

      }
      return true;
    });
    

    if(this.state.userActive === false){
      errorExist += field_error(e.target.email, null, {
        iserror: true,
        message: 'User Deactivated',
      }, 'email');
    }

    if(this.state.userAlreadyInWaitingList === true){
      errorExist += field_error(e.target.email, null, {
        iserror: true,
        message: 'User Already In Waiting List',
      }, 'email');
    }

    // //console.log('not skipped',errorExist);
    if (this.state.userexist)
      errorExist += field_error(e.target.email, null, {
        iserror: this.state.userexist,
        message: 'User Already subscribed',
      }, 'email');
    if (this.state.useradded)
      errorExist += field_error(e.target.email, null, {
        iserror: this.state.useradded,
        message: 'User Already added',
      }, 'email');

      if (this.state.useraddedphone)
        errorExist += field_error(e.target.phone, null, {
        iserror: this.state.useraddedphone,
        message: 'User Already added',
      }, 'phone');

    var res = await CartService.checkMobileNumber(
          data,
          this.state.type + '_' + this.state.id,
          this.state.learnerindex
        );
    if(res && res.error){
      errorExist += field_error(e.target.phone, null, {
        iserror: true,
        message: 'Phone number exist',
      }, 'phone');
    }   

    if (errorExist == 0) {
      this.loadingFormHandler();
      if (this.state.id) {
        var res = await CartService.addWaitingListLearner(
          data,
          this.state.type + '_' + this.state.id,
          this.state.learnerindex,
          this.state.isedit
        );
        if(res == "phone"){
          errorExist += field_error(e.target.phone, null, {
            iserror: this.state.useraddedphone,
            message: 'User Already added',
          }, 'phone');
        }
        var mem_enabled = CartService.checkmemEnabled(
          data,
          this.state.type + '_' + this.state.id
        );
        this.dissmisswaitmodal();
        if (mem_enabled == '1' || mem_enabled == '2') {
          this.props.show_membermsg(mem_enabled);
        } else {
          if (this.state.frompopup != 1) {
            this.props.refresh();
          }
        }
        this.setState({
          loadingMsg: '',
        });
      } else {
        // localStorage.setItem('dc_form',JSON.stringify(data));
        this.props.submit(JSON.stringify(data));
      }
    }
  };

  check_learner = (e,index="email") => {
    var skip = false;
    var pskip = false;
    // if (e.target.value) {
      var key =
        (this.state.type ? this.state.type : '') +
        '_' +
        (this.state.id ? this.state.id : '');
      var learner = Object.keys(CartService.getLearner(key));

      // edit case

      
      let checkobject = {
          email : this.state.email ?? "",
          phone : this.state.phone ?? ""
        }
      
      if(index == "phone"){
       // phone = e.target.value
        pskip = this.props.setdata && this.props.setdata.phone == e.target.value;
        this.setState({ phone: e.target.value });
        checkobject.phone = e.target.value
      }
      if(index == "email"){
        //email = e.target.value
        skip = this.props.setdata && this.props.setdata.email == e.target.value;
        this.setState({ email: e.target.value });
        checkobject.email = e.target.value
      }
      
      // 1 edits email to same mail (not block)
      // edits email to another user email block
      // if(index == "email"){

      if (
        JSON.stringify(learner)
          .toLowerCase()
          .search(
            e.target.value.toLowerCase().replace(/[^A-Za-z0-9_]/g, '\\$&') + '"'
          ) != -1 &&
        !skip
      ) {
        var error_index = 'email';
        var message = 'User already added';
        var error = field_error(e.target, null, { iserror: true, message }, error_index);
        this.setState({
          event_warning: false,
          useradded: true,
        },);
        return;
      } else {
        var error_index = 'email';
        var message = 'User already added';
        var error = field_error(e.target, null, { iserror: false, message }, error_index);
        this.setState({
          useradded: false,
        });
      }
      fetch(api_url + '/check_learner', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          api: true,
          email: checkobject.email ?? "",
          phone: checkobject.phone ?? "",
          id: this.state.id ? this.state.id : '',
          type: this.state.type ? this.state.type : '',
        }),
      })
        .then((res) => res.json())
        .then((result) => {
          if(result && result.error && result.error == true && result.msg == "User Deactivated"){
            this.setState({
              userActive:false
            });
          }else{
            this.setState({
              userActive:true
            });
          }
          if(result && result.error && result.error == true && result.msg == "User Already In Waiting List"){
            this.setState({
              userAlreadyInWaitingList:true
            });
          }else{
            this.setState({
              userAlreadyInWaitingList:false
            });
          }
          if (!result.error && result.data) {
            var user = {
              id: result.data.id,
              name: result.data.name,
              email: result.data.email,
              phone: result.data.phone,
              country_code: result.data.country_code,
              has_pps: result.data.has_pps,
              pps_number: result.data.pps_number,
              pps_info_unavailable: result.data.pps_info_unavailable,
              pps_full_name: result.data.pps_full_name,
              pps_dob: result.data.pps_dob,
              pps_country: result.data.pps_country,
              pps_insurance_num: result.data.pps_insurance_num,
              pps_address: result.data.pps_address,
              pps_contractor_full_name: result.data.pps_contractor_full_name,
              pps_contractor_email: result.data.pps_contractor_email,
              pps_contractor_address: result.data.pps_contractor_address,
              pps_contractor_location: result.data.pps_contractor_location,
              _dynamic: result.data._dynamic,
            };
            document.getElementById("country_code_hidden").value = result.data.country_code;
            localStorage.setItem(`country_code_${result.data.id}`,result.data.country_code);
            // set metadata
            if (this.state.id) {
              CartService.save_metadata(
                this.state.type + '_' + this.state.id,
                user
              );
            } else {
              localStorage.setItem('_metadata', JSON.stringify(user));
            }

            this.setState({
              event_warning: result.warning,
              setdata: user,
              info_unavail: result.data.pps_info_unavailable,
              readonly: true,
              ppsswitch: result.data.has_pps,
              userexist: false,
            });
          } else if (!result.error) {
            // reset metadata
            let isEdit  = this.state.isedit;
            let setData = this.state.setdata;
            var user = {
              id: '',
              name: isEdit ? setData?.name : '',
              email: result?.email,
              phone: isEdit ? setData?.phone : '',
              country_code: isEdit ? setData?.country_code : '',
              has_pps: isEdit ? setData?.has_pps : '',
              pps_number: isEdit ? setData?.pps_number : '',
              pps_info_unavailable: isEdit ? setData?.pps_info_unavailable : '',
              pps_full_name: isEdit ? setData?.pps_info_unavailable : '',
              pps_dob: isEdit ? setData?.pps_dob : '',
              pps_country: isEdit ? setData?.pps_country : '',
              pps_insurance_num: isEdit ? setData?.pps_insurance_num : '',
              pps_address: isEdit ? setData?.pps_address : '',
              pps_contractor_full_name: isEdit ? setData?.pps_contractor_full_name : '',
              pps_contractor_email: isEdit ? setData?.pps_contractor_email : '',
              pps_contractor_address: isEdit ? setData?.pps_contractor_address : '',
              pps_contractor_location: isEdit ? setData?.pps_contractor_location : '',
              _dynamic: isEdit ? setData?._dynamic : '',
            };
            if (this.state.id) {
              CartService.save_metadata(
                this.state.type + '_' + this.state.id,
                user
              );
            } else {
              localStorage.setItem('_metadata', JSON.stringify(user));
            }
            this.setState({
              event_warning: result.warning,
              setdata: user,
              info_unavail: false,
              readonly: false,
              userexist: false,
            });
          } else {
            this.setState({
              event_warning: result.warning,
              userexist: true,
            });
          }
        })
        .then(() => {
          Yes;

          var error_index = 'email';
          var message = 'User already Subscribed';
          var error = field_error(e.target, null, {
            iserror: this.state.userexist,
            message,
          }, 'email');
          if (!error) {
            var event_message = {
              0: '',
              1: 'Oops! You got another event of the same course.',
              2: 'Oops! You got another event on the same date.',
              3: 'Oops! You got another event on the same date and under same course',
            };
            var error = warning(e.target, null, {
              iserror: this.state.event_warning != 0,
              message: event_message[this.state.event_warning],
            });
          }
          
        })
        .catch((error) => {
        });
  };

  changepps = (e) => {
    if (e.target.value != this.state.ppsswitch) {
    }
    this.setState({
      ppsswitch: e.target.value,
      clickedchange: true,
    });
  };

  changefn = (e) => {
    // parent class change handler is always called with field name and value
    this.setState({[e.target.name]: e.target.value});
  }

  changeCountryCode = (e) =>{
    document.getElementById("country_code").removeAttribute("readonly");
    document.getElementById("country_code_hidden").value = e.target.value;
    localStorage.setItem(`country_code_${this.state.setdata.id}`,e.target.value);
    if(this.state.setdata.id == "" && this.state.setdata.email != ""){
      localStorage.setItem(this.state.setdata.email,e.target.value);
    }
  }

  render() {
    let data   = this.state.setdata;
    let isEdit = this.state.isedit;
    
    if(data && data.id){
      data.country_code = localStorage.getItem(`country_code_${data.id}`);
    }
    if(data && data.id == "" && data.email != "" && localStorage.getItem(data.email)){
      data.country_code = localStorage.getItem(data.email);
    }
    var readonly = this.state.readonly;
    var info_unavail = this.state.info_unavail;
    const basic_needed = !__isLoggedin || _bfo;
    if (data && data.pps_info_unavailable != '')
      info_unavail = data.pps_info_unavailable;
    var pps_enabled,
      _metadata = null;
    if (this.state.id) {
      const item_details = CartService.getCartItem(
        this.state.type + '_' + this.state.id
      );
      pps_enabled = item_details.others.pps_required;
      if (data) {
        _metadata = CartService.get_metadata(
          this.state.type + '_' + this.state.id
        );
        if (_metadata) {
          _metadata = _metadata[data.email];
        }
      }
    } else {
      if (!this.state.id) {
        _metadata = localStorage._metadata
          ? JSON.parse(localStorage._metadata)
          : null;
      }
      pps_enabled = CartService.is_pps_required();
    }

    var __has_pps;
    if (data && data.has_pps !== '' && !this.state.clickedchange) {
      __has_pps = data && data.has_pps == '1' ? true : false;
    } else {
      this.state.clickedchange = false;
      __has_pps =
        this.state.ppsswitch == 1 || this.state.ppsswitch == '' ? true : false;
    }
    var rankey = Math.random();
    var __loaded_from_server =
      _metadata && _metadata.has_pps !== '' ? true : false;
    const section = document.querySelector( '.error-msg' );
    if(section){
      section.scrollIntoView( { behavior: 'smooth', block: 'start' } ); 
    }
    
    return (
      <div
        className="modal add_address_form show fade in"
        id="details-pps"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
          <input
                      type="hidden"
                      name="id"
                      id = "country_code_hidden"
                    />
        <div className="pps-details-sec">
          <form
            action="#"
            method="post"
            // action="#"
            id="addLearnerForm"
            onSubmit={this.addLearnerForm}
          >
            <div className="pps-form-header">
              <button
                type="button"
                className="close cart-close"
                onClick={this.dissmisswaitmodal}
              >
                ×
              </button>
              <h5>Learner Details</h5>
              <p className="pr-4">
                {/* Personal Public Service Number (PPSN) is a unique reference number given{" "} */}
                Enter the specific details of the new learner in the column
                below. Click the checkbox to add the new learner.
              </p>
            </div>
            <div className="learnerwrapper row">
            {basic_needed == 1 && (
            
              <div className="col-md-6">
                <div
                  key={data && data.name ? data.name : ''}
                  className="form-group form-group-alter "
                >
                  <span>
                    <label className={data && data.name || this.state.name ? 'active' : ''} style={{'text-transform': 'none'}}>
                      Full Name
                    </label>
                    <input
                      type="text"
                      autocomplete="off"
                      name="name"
                      id="name"
                      readOnly={!isEdit && _metadata && _metadata.name}
                      defaultValue={data && data.name ? data.name : ''}
                      className="form-control form-alter"                     
                      onChange={this.changefn}
                    />
                    <input
                      type="hidden"
                      name="id"
                      readOnly={_metadata && _metadata.id}
                      defaultValue={data && data.id ? data.id : ''}
                    />
                    <input
                      type="hidden"
                      id = "invalid_country_code"
                    />
                    <input
                      type="hidden"
                      name="oldIndex"
                      readOnly="readOnly"
                      defaultValue={
                        this.state.learnerindex ? this.state.learnerindex : ''
                      }
                    />
                    <div id="label_for_name" class="field-info"></div>
                  </span>
                </div>
              </div>
            )}
            {basic_needed == 1 && (
              <div className="col-md-6">
                <div className="form-group form-group-alter ">
                  <span>
                    <label className={data && data.email  || this.state.email ? 'active' : ''}>
                      Email Address
                    </label>
                    <input
                      autocomplete="off"
                      type="text"
                      name="email"
                      //
                      defaultValue={data && data.email ? data.email : ''}
                      onChange={(e) => setTimeout(() => {
                        this.check_learner(e,"email")
                      }, 200) }
                      className="form-control form-alter"
                    />
                    <label className="info-label"></label>
                    <div id="label_for_email" class="field-info"></div>
                  </span>
                </div>
              </div>
            )}
            {basic_needed == 1 && (
              <div className="col-md-6">
                <div className="form-group form-group-alter phone-number">
                  <span className="select-code" key={rankey}>
                    <label
                      className={
                        data && data.country_code || this.state.country_code
                          ? 'active'
                          : _userCountryCode
                            ? 'active'
                            : ''
                      }
                    >
                      Code
                    </label>
                    <input
                      type="text"
                      name="country_code"
                      id="country_code"
                      maxLength={10}
                      readOnly={!isEdit && _metadata && _metadata.country_code}
                      onChange = {this.changeCountryCode}
                      defaultValue={
                        data && data.country_code
                          ? data.country_code
                          : _userCountryCode
                            ? '+' + _country[_userCountryCode].calling_code
                            : ''
                      }
                      className="form-control form-alter"
                    />
                    <div id="label_for_country_code" class="field-info"></div>
                  </span>
                  <span
                    className="number"
                    key={data && data.phone ? data.phone : ''}
                  >
                    <label className={data && data.phone || this.state.phone ? 'active' : ''}>
                      Phone Number
                    </label>
                    <input
                      // type="number"
                      type={_metadata && _metadata.phone ? 'text' : 'number'}
                      name="phone"
                      maxLength={10}
                      readOnly={!isEdit && _metadata && _metadata.phone}
                      defaultValue={data && data.phone ? data.phone : ''}
                      className="form-control form-alter"
                      onChange={this.changefn}
                      // onChange={(e) => this.check_learner2(e,"phone")}
                    />
                    <div id="label_for_phone" class="field-info"></div>
                  </span>
                </div>
              </div>
            )}
            <Dynamic_field
              key={data && data._dynamic ? data._dynamic : ''}
              metadata={
                _metadata && _metadata._dynamic ? _metadata._dynamic : null
              }
              data={data && data._dynamic ? data._dynamic : null}
              isEdit={isEdit}
            />

            {/* {dynamic_fields()} */}
            {pps_enabled && (
              <div className="col-md-12 p-0">
                <span className="coupon-subtxt m-0">
                  Do you have a PPS number?
                </span>
                <div
                  className="d-flex mt-05 ppc-choose"
                  style={{
                    'pointer-events': __loaded_from_server ? 'none' : 'auto',
                  }}
                >
                  <span>
                    <input
                      key={rankey}
                      type="radio"
                      id="pps_yes"
                      className="pps_radio"
                      name="has_pps"
                      defaultValue={1}
                      onClick={this.changepps}
                      // readOnly={_metadata && _metadata.has_pps}
                      defaultChecked={__has_pps}
                    // defaultChecked={(data && data.has_pps == '1') ? true : ((!data) ? true : false)}
                    />
                    <label htmlFor="pps_yes">Yes</label>
                  </span>
                  <span className="no-ppc-sec">
                    <input
                      key={rankey}
                      type="radio"
                      id="pps_no"
                      className="pps_radio"
                      defaultValue={0}
                      onClick={this.changepps}
                      name="has_pps"
                      // readOnly={_metadata && _metadata.has_pps}
                      defaultChecked={!__has_pps}
                    // defaultChecked={(data && data.has_pps == '0') ? true : false}
                    />
                    <label htmlFor="pps_no">No</label>
                  </span>
                </div>
              </div>
            )}

            {pps_enabled && (
              <div
                className="pps-member-sec"
                id="pps_number_form"
                style={__has_pps ? { display: 'block' } : { display: 'none' }}
              >
                {/* style={data && !data.has_pps?{ display: "none" }:{display:'block'}}> */}
                <div className="col-md-9 pl-0 pr-2 sm-pd-0">
                  <div className="form-group form-group-alter ">
                    <span>
                      <label
                        className={data && data.pps_number ? 'active' : ''}
                      >
                        PPS Number
                      </label>
                      <input
                        type="text"
                        name="pps_number"
                        readOnly={_metadata && _metadata.pps_number}
                        // readOnly={readonly && (data && data.pps_number) ? data.pps_number : ''}
                        defaultValue={
                          data && data.pps_number ? data.pps_number : ''
                        }
                        className="form-control form-alter"
                      />
                    </span>
                  </div>
                </div>
              </div>
            )}

            {pps_enabled && (
              <div
                className="pps-no-member-sec mt-05"
                id="pps_detailed_form"
                style={!__has_pps ? { display: 'block' } : { display: 'none' }}
              // style={data && data.has_pps?{ display: "none" }:{display:'block'}}
              >
                <span className="coupon-subtxt">Enter STB Form</span>
                <span
                  key={rankey}
                  className="info-checkbox"
                  style={{
                    'pointer-events':
                      _metadata && _metadata.pps_info_unavailable !== ''
                        ? 'none'
                        : 'auto',
                  }}
                >
                  <input
                    name="pps_info_unavailable"
                    defaultChecked={info_unavail}
                    onChange={this.information_unaviabled}
                    type="checkbox"
                  />{' '}
                  Information Unavailable
                </span>
                <span className="cart-sub-text">Candidate Details</span>
                <div className="row">
                  <div className="col-md-6 pr-1">
                    <div className="form-group">
                      <input
                        type="text"
                        name="pps_full_name"
                        readOnly={
                          (_metadata && _metadata.pps_full_name) || info_unavail
                        }
                        defaultValue={
                          data && data.pps_full_name ? data.pps_full_name : ''
                        }
                        id="pps_full_name"
                        className="form-control"
                      // required
                      />
                      <label
                        className={
                          data && data.pps_full_name
                            ? 'form-control-placeholder active'
                            : 'form-control-placeholder'
                        }
                        htmlFor="pps_full_name" style={{'text-transform': 'none'}}
                      >
                        First and Last Name
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6 pl-1 pd-sm">
                    <div className="form-group dob-select">
                      <input
                        name="pps_dob"
                        id="pps_dob"
                        className="form-control"
                        // required
                        type={_metadata && _metadata.pps_dob ? 'text' : 'date'}
                        readOnly={
                          (_metadata && _metadata.pps_dob) || info_unavail
                        }
                        defaultValue={data && data.pps_dob ? data.pps_dob : ''}
                      />
                      <label
                        // className="form-control-placeholder"
                        className={
                          data && data.pps_dob
                            ? 'form-control-placeholder  date-label active'
                            : 'form-control-placeholder  date-label'
                        }
                        htmlFor="pps_dob"
                      >
                        DOB
                      </label>
                      <svg
                        className="dob-svg"
                        xmlSpace="preserve"
                        enableBackground="new 0 0 30 30"
                        viewBox="0 0 1000 1000"
                        y="0px"
                        x="0px"
                        version="1.1"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ height: 41, width: 15 }}
                      >
                        <g>
                          <path d="M867.2,131.4h-58.5V53.6c0-24.6-20.2-44.8-44.8-44.8h-2.4c-24.6,0-44.8,20.2-44.8,44.8v77.8h-430V53.6c0-24.6-20.2-44.8-44.8-44.8h-2.4c-24.6,0-44.8,20.2-44.8,44.8v77.8h-61.9C65.3,131.4,10,186.7,10,254.2v614.1c0,67.6,55.3,122.8,122.8,122.8h734.4c67.6,0,122.8-55.3,122.8-122.8V254.2C990,186.7,934.7,131.4,867.2,131.4z M900.4,899H100.8V407.8h799.6V899z M900.4,314.4H100.8V221h799.6V314.4z" />
                        </g>
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 pr-1">
                    <div className="form-group country-select country_type">
                      <select
                        name="pps_country"
                        id="pps_country"
                        readOnly={
                          (_metadata && _metadata.pps_country) || info_unavail
                        }
                        // defaultValue={(data&&data.pps_country)?data.pps_country:''}
                        className="form-control"
                      >
                        <option value="">Select a country</option>
                        {this.state.countries.map((item, i) => {
                          return (
                            <option
                              value={item.id}
                              selected={
                                data && item.id == data.pps_country
                                  ? true
                                  : false
                              }
                            >
                              {item.country_name}
                            </option>
                          );
                        })}
                      </select>

                      <label
                        className={
                          data && data.pps_country
                            ? 'form-control-placeholder active'
                            : 'form-control-placeholder'
                        }
                        htmlFor="pps_country"
                      >
                        Country
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6 pl-1 pd-sm">
                    <div className="form-group">
                      <input
                        type={
                          _metadata && _metadata.pps_insurance_num
                            ? 'text'
                            : 'number'
                        }
                        name="pps_insurance_num"
                        readOnly={
                          (_metadata && _metadata.pps_insurance_num) ||
                          info_unavail
                        }
                        defaultValue={
                          data && data.pps_insurance_num
                            ? data.pps_insurance_num
                            : ''
                        }
                        id="pps_insurance_num"
                        className="form-control"
                      // required
                      />
                      <label
                        className={
                          data && data.pps_insurance_num
                            ? 'form-control-placeholder active'
                            : 'form-control-placeholder'
                        }
                        htmlFor="pps_insurance_num"
                      >
                        National Insurance Number
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        name="pps_address"
                        readOnly={
                          (_metadata && _metadata.pps_address) || info_unavail
                        }
                        defaultValue={
                          data && data.pps_address ? data.pps_address : ''
                        }
                        id="pps_address"
                        className="form-control"
                      // required
                      />
                      <label
                        className={
                          data && data.pps_address
                            ? 'form-control-placeholder active'
                            : 'form-control-placeholder'
                        }
                        htmlFor="pps_address"
                      >
                        Address
                      </label>
                    </div>
                  </div>
                </div>
                <span className="cart-sub-text">Contractor Details</span>
                <div className="row">
                  <div className="col-md-6 pr-1">
                    <div className="form-group">
                      <input
                        type="text"
                        name="pps_contractor_full_name"
                        readOnly={
                          (_metadata && _metadata.pps_contractor_full_name) ||
                          info_unavail
                        }
                        defaultValue={
                          data && data.pps_contractor_full_name
                            ? data.pps_contractor_full_name
                            : ''
                        }
                        id="pps_contractor_full_name"
                        className="form-control"
                      // required
                      />
                      <label
                        className={
                          data && data.pps_contractor_full_name
                            ? 'form-control-placeholder active'
                            : 'form-control-placeholder'
                        }
                        htmlFor="pps_contractor_full_name" style={{'text-transform': 'none'}}
                      >
                        First and Last Name
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6 pl-1 pd-sm">
                    <div className="form-group">
                      <input
                        type="text"
                        name="pps_contractor_email"
                        readOnly={
                          (_metadata && _metadata.pps_contractor_email) ||
                          info_unavail
                        }
                        defaultValue={
                          data && data.pps_contractor_email
                            ? data.pps_contractor_email
                            : ''
                        }
                        id="pps_contractor_email"
                        className="form-control"
                      // required
                      />
                      <label
                        className={
                          data && data.pps_contractor_email
                            ? 'form-control-placeholder active'
                            : 'form-control-placeholder'
                        }
                        htmlFor="pps_contractor_email"
                      >
                        Email Address
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        name="pps_contractor_address"
                        readOnly={
                          (_metadata && _metadata.pps_contractor_email) ||
                          info_unavail
                        }
                        defaultValue={
                          data && data.pps_contractor_address
                            ? data.pps_contractor_address
                            : ''
                        }
                        id="pps_contractor_address"
                        className="form-control"
                      // required
                      />
                      <label
                        className={
                          data && data.pps_contractor_address
                            ? 'form-control-placeholder active'
                            : 'form-control-placeholder'
                        }
                        htmlFor="pps_contractor_address"
                      >
                        Address (in Ireland)
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        name="pps_contractor_location"
                        readOnly={
                          (_metadata && _metadata.pps_contractor_email) ||
                          info_unavail
                        }
                        defaultValue={
                          data && data.pps_contractor_location
                            ? data.pps_contractor_location
                            : ''
                        }
                        id="pps_contractor_location"
                        className="form-control"
                      // required
                      />
                      <label
                        className={
                          data && data.pps_contractor_location
                            ? 'form-control-placeholder active'
                            : 'form-control-placeholder'
                        }
                        htmlFor="pps_contractor_location"
                      >
                        Site Location (in Ireland)
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {_concent.status && (
              <div className="declaration-box">
                <div className="cart_purchase_info">
                  {_concent.purchase_concerns_request}
                </div>
                <span className="info-checkbox">
                  <input
                    name="concent"
                    value="1"
                    type="checkbox"
                    defaultChecked={this.props.setdata ? true : false}
                  />
                  <span>
                    {_concent.purchase_concerns_response}
                    <div
                      class="cart_purchase_info"
                      dangerouslySetInnerHTML={{
                        __html: _concent.purchase_concerns_description,
                      }}
                    ></div>
                  </span>
                </span>
              </div>
            )}
            </div>
            {this.state.id && (
              <div className="bulk-cart-btn">
                <div className="btn cart-btn h-45 mt-2 theme-blue-btn1 w-75 mr-center-align">
                  {/* <a href="javascript:void(0)" id="pps_form_btn">
							Add Address
						</a> */}
                  <button
                    className="leanerbutton"
                    id="pps_form_btn"
                    type="submit"
                  >
                    {this.state.loadingMsg == ''
                      ? this.props.setdata && this.props.setdata.email
                        ? 'Save Learner'
                        : 'Add Learner'
                      : this.state.loadingMsg}
                    {/* Save Learner   */}
                  </button>
                </div>
              </div>
            )}
            
            {!this.state.id && (
              <div className="bulk-cart-btn">
                <div className="btn cart-btn h-45 mt-2 theme-blue-btn1 w-75 mr-center-align">
                  <button
                    id="pps_form_btn"
                    type="submit"
                    className="proceed-btn orange-flat-btn proceedsubmit"
                  >
                    Proceed
                  </button>
                </div>
              </div>
            )}
          </form>
        </div>
      </div>
    );
  }
}

/*  
      {this.state.showpopup2 && coupondiscount ? (
          <CouponApplied
            coupondiscount={coupondiscount}
            cb_dismiss={this.removeCouponAppliedpopup}
          />
        ) : (
          <div></div>
        )}
*/

export class MemberpriceApplied extends React.Component {
  constructor(props) {
    document.body.className += ' disable_background_scroll';
    super(props);
  }
  dismiss = () => {
    document.body.className = document.body.className.replace(
      'disable_background_scroll',
      ''
    );
    this.props.dissmissmodal_membermsg();
  };
  render() {
    return (
      <div
        className="modal show"
        id="couponcode-applied"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="coupon-applied-section">
          <div className="coupon-code-icon">
            {this.props.membermsg == '1' ? (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="44"
                height="44"
                viewBox="0 0 44 44"
              >
                <g
                  id="Group_20711"
                  data-name="Group 20711"
                  transform="translate(-7529.5 -12571.5)"
                >
                  <circle
                    id="Ellipse_434"
                    data-name="Ellipse 434"
                    cx="22"
                    cy="22"
                    r="22"
                    transform="translate(7529.5 12571.5)"
                    fill="#539a86"
                  />
                  <path
                    id="Path_42"
                    data-name="Path 42"
                    d="M49.849,14.367a1.264,1.264,0,0,0-1.788,0L36.317,26.111,32.156,21.95a1.264,1.264,0,1,0-1.788,1.788l5.055,5.055a1.264,1.264,0,0,0,1.788,0L49.849,16.156a1.264,1.264,0,0,0,0-1.788Z"
                    transform="translate(7511.177 12571.696)"
                    fill="#fff"
                    stroke="#fff"
                    stroke-width="1"
                  />
                </g>
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="44"
                height="44"
                viewBox="0 0 44 44"
              >
                <g
                  id="Group_20711"
                  data-name="Group 20711"
                  transform="translate(-7529.5 -12571.5)"
                >
                  <circle
                    id="Ellipse_434"
                    data-name="Ellipse 434"
                    cx="22"
                    cy="22"
                    r="22"
                    transform="translate(7529.5 12571.5)"
                    fill="#e8d464"
                  />
                  <line
                    id="Line_1495"
                    data-name="Line 1495"
                    y2="10.673"
                    transform="translate(7551.5 12585.327)"
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-width="4"
                  />
                  <circle
                    id="Ellipse_435"
                    data-name="Ellipse 435"
                    cx="2"
                    cy="2"
                    r="2"
                    transform="translate(7549.5 12599.5)"
                    fill="#fff"
                  />
                </g>
              </svg>
            )}
          </div>
          <p>
            {this.props.membermsg == '1' ? _memberSuccessmsg : _memberFailmsg}
          </p>
          <div className="border-bottom mt-15 w-100" />
          <div
            className="bluetext mt-15 cart-success-text"
            onClick={this.dismiss}
          >
            Close
          </div>
        </div>
      </div>
    );
  }
}

export class CouponNotAllowed extends React.Component {
  constructor(props) {
    document.body.className += ' disable_background_scroll';
    super(props);
  }
  dismiss = () => {
    // __prev_dis = this.props.coupondiscount.toFixed(2);
    this.props.removeCoupon();
    document.body.className = document.body.className.replace(
      'disable_background_scroll',
      ''
    );
    this.props.cb_dismiss();
  };
  render() {
    return (
      <div
        className="modal show"
        id="couponcode-applied"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="coupon-applied-section">
          <div className="coupon-code-icon">
          </div>
          <p>
            Apologies ! Applied Coupon Code Not Available Now
          </p>
          <span>
            Please apply again
          </span>
          <br/>
          <div className="border-bottom mt-15 w-100" />
          <div
            className="bluetext mt-15 cart-success-text"
            onClick={this.dismiss}
          >
            Close
          </div>
        </div>
      </div>
    );
  }
}